<template>
  <div>
    <v-container fluid>
      <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('_DocumentManagement') }}</v-toolbar-title>
        <v-spacer />
        <div class="d-flex pr-4">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
        </div>
      </v-toolbar>
      <div class="card2">
        <v-flex>
          <!-- Document Configuration Section -->
          <div class="config-wrapper">
            <!-- Configuration Form -->
            <v-card class="config-card" elevation="0" variant="outlined">
              <v-card-text class="config-content">
                <!-- Basic Information Section -->
                <div class="form-section">
                  <h3 class="subsection-title">
                    <v-icon class="subsection-icon">mdi-information-outline</v-icon>
                    Basic Information
                  </h3>
                  <v-row class="form-row">
                    <v-col cols="12" md="6" lg="3">
                      <div class="input-wrapper">
                        <label class="input-label">Document Name</label>
                        <v-text-field
                          id="documentname-field-uploadvector"
                          @keypress="handleKeypress"
                          @paste="handlePaste"
                          :rules="[checkValidate()]"
                          :disabled="actionEdit"
                          v-model="searchVectorDBName2"
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          placeholder="Enter unique document name"
                          prepend-inner-icon="mdi-file-document"
                        >
                          <template v-slot:append-inner>
                            <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-help-circle-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoVectorDatabaseName') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>

                    <v-col cols="12" md="6" lg="3">
                      <div class="input-wrapper">
                        <label class="input-label">Text Replacement</label>
                        <v-autocomplete
                          id="textreplacement-autocomplete-uploadvector"
                          :items="DDGroupReplace"
                          item-title="name"
                          item-value="id"
                          multiple
                          chips
                          closable-chips
                          clearable
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          placeholder="Select replacement rules"
                          v-model="tempgroupReplaceID"
                        >
                          <template v-slot:append-inner>
                            <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-help-circle-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoGroupReplaceText') }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>

                    <v-col cols="12" md="6" lg="3">
                      <div class="input-wrapper">
                        <label class="input-label">{{ $t('process_type') }}</label>
                        <v-select :items="filteredModeType" item-title="name" item-value="value" variant="outlined" density="compact" hide-details="auto" v-model="requestVector.deleteAll" :disabled="filteredModeType.length <= 1">
                          <template v-slot:append-inner>
                            <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-help-circle-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoProcess_type') }}</span>
                            </v-tooltip>
                          </template>
                        </v-select>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Document Type Section -->
                <v-divider class="section-divider"></v-divider>

                <div class="form-section">
                  <h3 class="subsection-title">
                    <v-icon class="subsection-icon">mdi-file-multiple</v-icon>
                    Document Type & Processing
                  </h3>
                  <v-row class="form-row">
                    <!-- DocType dropdown commented out - now using file-first flow -->
                    <!-- <v-col cols="12" md="2">
                      <div class="input-wrapper">
                        <label class="input-label">{{ $t('doctype') }}</label>
                        <v-select
                          id="doctype-select-uploadvector"
                          :error="!!errors.doctypeError"
                          :error-messages="errors.doctypeError"
                          :rules="[rules.required]"
                          :items="datadoctype"
                          item-title="name"
                          item-value="value"
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          v-model="doctype"
                          return-object
                          @update:model-value="setTypeFile(doctype.value)"
                        >
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" :id="'doctype-option-' + item.raw.id" :value="item.raw.value">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:append-inner>
                            <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-help-circle-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoDoctype') }}</span>
                            </v-tooltip>
                          </template>
                        </v-select>
                      </div>
                    </v-col> -->

                    <!-- Pick File Button - just selects file without uploading -->
                    <v-col cols="12" md="2">
                      <div class="input-wrapper">
                        <label class="input-label">Select File</label>
                        <input
                          type="file"
                          ref="hiddenFileInput"
                          :accept="accept"
                          style="display: none"
                          @change="handleFilePick"
                        />
                        <v-btn
                          id="button-pickfile-uploadvector"
                          variant="outlined"
                          color="primary"
                          prepend-icon="mdi-file-plus"
                          class="pick-file-btn"
                          style="width: 100%; height: 40px;"
                          :disabled="!canAdd && !canEdit"
                          @click="openFilePicker()"
                        >
                          {{ isFileSelected ? uploadedFiles[0].name.substring(0, 15) + '...' : 'Pick File' }}
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col cols="12" md="2">
                      <div class="input-wrapper">
                        <label class="input-label">{{ $t('vectortype') }}</label>
                        <v-select
                          id="vectortype-select-uploadvector"
                          :error="!!errors.vectortypeError"
                          :error-messages="errors.vectortypeError"
                          :rules="[rules.required]"
                          :items="filterdatavectortype"
                          item-title="name"
                          item-value="value"
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          v-model="vectortype"
                          return-object
                          :disabled="!isFileSelected"
                        >
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" :id="'vectortype-option-' + item.raw.id" :value="item.raw.value">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:append-inner>
                            <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-help-circle-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoVectortype') }}</span>
                            </v-tooltip>
                          </template>
                        </v-select>
                      </div>
                    </v-col>

                    <v-col cols="12" md="2">
                      <div class="input-wrapper">
                        <label class="input-label">Processing Method</label>
                        <v-autocomplete
                          id="type-autocomplete-uploadvector"
                          :error="!!errors.modelTypeError"
                          :error-messages="errors.modelTypeError"
                          :items="filterDDType"
                          item-title="name"
                          item-value="value"
                          clearable
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          :rules="[rules.required]"
                          v-model="requestVector.modelType"
                          :disabled="!vectortype"
                        >
                          <template v-slot:item="{ props, item }">
                            <v-list-item :id="'vectortype-option-' + item.raw.id" :value="item.raw.value" v-bind="props" :title="item.raw.name" class="processing-item">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                              <template v-slot:append>
                                <v-tooltip location="right" max-width="400px">
                                  <template v-slot:activator="{ props }">
                                    <v-icon v-bind="props" size="small" class="help-icon">mdi-information-outline</v-icon>
                                  </template>
                                  <div class="tooltip-image">
                                    <img :src="item.raw.image" width="300" />
                                  </div>
                                </v-tooltip>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:append-inner>
                            <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-help-circle-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfofillterModelType') }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>

                    <v-col cols="12" md="2" v-show="requestVector.modelType == 3 || requestVector.modelType == 11">
                      <div class="input-wrapper">
                        <label class="input-label">Custom Character</label>
                        <v-text-field
                          id="customcharacter-field-uploadvector"
                          v-model="requestVector.customCharacter"
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          placeholder="Enter character"
                          :rules="[checkCustomCharacterValidate()]"
                        >
                          <template v-slot:append-inner>
                            <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-help-circle-outline</v-icon>
                              </template>
                              <span>ADD คือฝระบวนฝารเพิ่มข้อมูลลง Vector, Replace คือฝระบวนฝาร๝ฝ้ไขคำต</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Action Section -->
                <v-divider class="section-divider" style="margin-top: 0px"></v-divider>

                <div class="action-section">
                  <div class="upload-action-wrapper">
                    <!-- Upload button - uses already picked file, calls API -->
                    <v-btn
                      id="button-upload-uploadvector"
                      prepend-icon="mdi-upload"
                      class="styled-upload-btn"
                      :disabled="!canAdd && !canEdit"
                      @click="triggerUpload()"
                    >
                      Upload
                    </v-btn>
                  </div>
                  <div class="action-left">
                    <!-- <v-btn id="button-template-uploadvector" variant="outlined" color="secondary" prepend-icon="mdi-download" class="template-btn" @click="TemplateVectorDialog()"> Template </v-btn> -->
                    <v-btn id="button-template-uploadvector" variant="outlined" class="template-btn" @click="TemplateVectorDialog()">
                      <v-img :src="templateIcon" alt="Edit Icon" height="22" width="22" class="mr-2" />
                      Template
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>

          <!-- Document Configuration Management Section -->
          <div class="config-management-wrapper">
            <v-card class="config-management-card" elevation="2">
              <v-card-title class="config-management-title">
                <v-icon class="mr-2" color="primary">mdi-cog</v-icon>
                <span>Document Configuration</span>
              </v-card-title>
              <v-card-text class="config-management-content">
                <v-row class="form-row">
                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Max Character Limit</label>
                      <v-text-field
                        @keypress="numericKey"
                        v-model="configForm.MaxLimitedCharacter"
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        placeholder="e.g., 1000"
                        prepend-inner-icon="mdi-format-text"
                      />
                    </div>
                  </v-col>

                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Effective Start Date</label>
                      <VueDatePicker
                        v-model="configForm.effectiveStartDate"
                        placeholder="Select start date"
                        :enable-time-picker="false"
                        :format="'dd/MM/yyyy'"
                        model-type="yyyy-MM-dd"
                        text-input
                        auto-apply
                        :max-date="configForm.effectiveEndDate"
                        :teleport="true"
                        class="custom-datetime-picker"
                      />
                    </div>
                  </v-col>

                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Effective End Date</label>
                      <VueDatePicker
                        v-model="configForm.effectiveEndDate"
                        placeholder="Select end date"
                        :enable-time-picker="false"
                        :format="'dd/MM/yyyy'"
                        model-type="yyyy-MM-dd"
                        text-input
                        auto-apply
                        :min-date="configForm.effectiveStartDate"
                        :teleport="true"
                        class="custom-datetime-picker"
                      />
                    </div>
                  </v-col>

                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Knowledge Category</label>
                      <v-select
                        :items="knowledgeCategories"
                        item-title="name"
                        item-value="value"
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        v-model="configForm.knowledgeType"
                        placeholder="Select category"
                      />
                    </div>
                  </v-col>
                </v-row>

                <!-- Title, SubTitle, Chunk Overlap Row - shown when Context by LLM selected or has existing values -->
                <v-row class="form-row" v-show="showConfigTitleSubTitle">
                  <!-- Title dropdown -->
                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Title<span v-if="isTitleRequired" class="required-asterisk">*</span></label>
                      <v-select
                        :items="titleOptions"
                        item-title="name"
                        item-value="value"
                        :clearable="!isTitleRequired"
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        v-model="configForm.Title"
                        @update:model-value="onConfigTitleChange"
                        placeholder="Select title"
                        :rules="isTitleRequired ? [v => !!v || 'Title is required'] : []"
                        :error="isTitleRequired && !configForm.Title"
                      />
                    </div>
                  </v-col>

                  <!-- SubTitle dropdown -->
                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Sub-Title<span v-if="isSubTitleRequired" class="required-asterisk">*</span></label>
                      <v-select
                        :items="configAvailableSubTitles"
                        item-title="name"
                        item-value="value"
                        :clearable="!isSubTitleRequired"
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        v-model="configForm.SubTitle"
                        placeholder="Select sub-title"
                        :disabled="!configForm.Title || configAvailableSubTitles.length === 0"
                        :rules="isSubTitleRequired ? [v => !!v || 'Sub-Title is required'] : []"
                        :error="isSubTitleRequired && !configForm.SubTitle"
                      />
                    </div>
                  </v-col>

                  <!-- Chunk Overlap (Lap) input -->
                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Chunk Overlap (Lap)</label>
                      <v-text-field
                        v-model.number="configForm.chunkOverlapChars"
                        type="number"
                        min="0"
                        max="1000"
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        placeholder="0"
                      />
                    </div>
                  </v-col>
                </v-row>

                <v-row class="form-row">
                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Language Detection</label>
                      <div class="switch-container-LangDetect">
                        <v-switch
                          v-model="configForm.DetectLanguage"
                          color="primary"
                          inset
                          hide-details
                          class="language-switch"
                        >
                          <template v-slot:label>
                            <span class="switch-text">
                              {{ configForm.DetectLanguage ? 'Auto Detection' : 'Manual Mode' }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Personal Information</label>
                      <div class="switch-container-personal">
                        <v-switch
                          v-model="configForm.PersonalInfo"
                          color="warning"
                          inset
                          hide-details
                          class="personal-switch"
                        >
                          <template v-slot:label>
                            <span class="switch-text">
                              {{ configForm.PersonalInfo ? 'Detection ON' : 'Detection OFF' }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" md="3">
                    <div class="input-wrapper">
                      <label class="input-label">Active Status</label>
                      <div class="switch-container-LangDetect">
                        <v-switch
                          v-model="configForm.activeStatus"
                          color="primary"
                          inset
                          hide-details
                          class="language-switch"
                        >
                          <template v-slot:label>
                            <span class="switch-text">
                              {{ configForm.activeStatus ? 'Active' : 'Inactive' }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </div>
                  </v-col>

                  <v-col v-if="canEdit" cols="12" md="3" class="d-flex align-end">
                    <v-btn
                      color="primary"
                      variant="flat"
                      prepend-icon="mdi-content-save"
                      class="update-config-btn"
                      @click="UpdateConfiguration()"
                      :loading="configLoading"
                      block
                    >
                      Update Configuration
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>

          <!-- Search and Management Section -->
          <div class="search-wrapper">
            <div class="search-card" elevation="0" variant="outlined">
              <div class="search-content">
                <v-row class="search-row" align="center">
                  <v-col cols="12" md="4">
                    <div class="input-wrapper">
                      <v-text-field
                        id="add-field-search-uploadvector"
                        v-model="searchtext_org"
                        variant="outlined"
                        density="compact"
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        clearable
                        placeholder="Search in document content"
                        @keyup.enter="Search"
                      >
                        <template v-slot:append-inner>
                          <v-btn id="add-button-search-uploadvector" color="primary" variant="flat" size="small" class="search-btn ml-2" @click="Search"> Search </v-btn>
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>

                  <v-col cols="12" md="8">
                    <div class="action-controls-uploadvector" style="background-color: transparent; border: none">
                      <v-btn v-if="canEdit" id="button-reprocess-uploadvector" color="orange-lighten-1" variant="flat" prepend-icon="mdi-file-sync" icon-color="white" class="action-btn" @click="ReProcess()">
                        Reprocess
                        <span v-if="needsReprocessing" class="notification-badge"
                          >!</span
                        >
                      </v-btn>

                      <v-btn color="info" variant="outlined" prepend-icon="mdi-information" class="info-btn" @click="ReFresh()"> {{ dataUpdate }} / {{ dataAll }} </v-btn>

                      <v-btn v-if="canAdd" id="button-adddocumentperchunk-uploadvector" color="success" variant="flat" prepend-icon="mdi-plus" class="action-btn" @click="AddVectorperChunk()">
                        {{ $t('add') }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="settings-row">
                  <v-col cols="12" class="d-flex justify-end" style="margin: 0">
                    <div class="toggle-section">
                      <v-switch v-model="CheckboxShowAllText" color="primary" hide-details density="compact" inset class="compact-toggle" id="add-checkbox-search-uploadvector">
                        <template #label>
                          <div class="toggle-label">
                            <v-icon size="20" class="mr-1" :color="CheckboxShowAllText ? 'primary' : 'grey'"> mdi-text-long </v-icon>
                            <span style="font-size: 1rem">{{ $t('_ShowAllText') }}</span>
                          </div>
                        </template>
                      </v-switch>
                      <v-switch v-model="CheckboxShowMarkdown" color="primary" hide-details density="compact" inset class="compact-toggle" id="add-checkbox-markdown-uploadvector">
                        <template #label>
                          <div class="toggle-label">
                            <v-icon size="20" class="mr-1" :color="CheckboxShowMarkdown ? 'primary' : 'grey'"> mdi-language-markdown </v-icon>
                            <span style="font-size: 1rem">{{ $t('_ShowMarkdown') }}</span>
                          </div>
                        </template>
                      </v-switch>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <v-data-table-server
                id="datatable-uploadvertor"
                v-if="showTable == true"
                v-model:options="options2"
                :items-per-page="itemsPerPage2"
                :total-items="searchTotalTable2"
                :items="dataTable2"
                :headers="headers2"
                :loading="loadingTable"
                loading-text="Loading..."
                fixed-header
                mobile-breakpoint="300"
                :items-length="searchTotalTable2"
                class="elevation-1 responsive-table"
              >
                <!-- ใช้ v-slot:item.[column] ๝ทน v-slot:item เพื่อ custom column -->
                <template v-slot:item.number="{ item }">
                  {{ item.number }}
                </template>

                <template v-slot:item.textORG="{ item }">
                  <div class="text-container" :class="{ 'markdown-mode': CheckboxShowMarkdown }">
                    <MarkdownRenderer
                      v-if="CheckboxShowMarkdown"
                      :source="formatMarkdownText(item.textORG)"
                      :class="[item.show ? 'text-content-show' : 'text-content']"
                    />
                    <span
                      v-else
                      :class="[item.show ? 'text-content-show' : 'text-content']"
                      v-html="formatText(item.textORG)"
                    ></span>
                  </div>
                </template>

                <template v-slot:item.textEN="{ item }">
                  <div class="text-container" :class="{ 'markdown-mode': CheckboxShowMarkdown }">
                    <MarkdownRenderer
                      v-if="CheckboxShowMarkdown"
                      :source="formatMarkdownText(item.textEN)"
                      :class="[item.show ? 'text-content-show' : 'text-content']"
                    />
                    <span
                      v-else
                      :class="[item.show ? 'text-content-show' : 'text-content']"
                      v-html="formatText(item.textEN)"
                    ></span>
                    <v-btn icon variant="text" size="small" color="primary" @click="item.show = !item.show">
                      <v-icon size="18">{{ item.show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      <v-tooltip activator="parent" location="top">
                        {{ item.show ? 'Collapse text' : 'Expand text' }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </template>

                <template v-slot:item.actions="{ item }">
                  <div class="actions-container">
                    <!-- Vector Switch with Label -->
                    <div class="switch-container">
                      <v-switch
                        inset
                        id="switch-vectoronoff-uploadvector"
                        v-model="item.activeFlag"
                        @update:model-value="VectorOnOff(item)"
                        color="success"
                        density="compact"
                        hide-details
                        :disabled="!canEdit"
                        class="vector-switch"
                      >
                      </v-switch>
                      <span class="switch-label">
                        {{ item.activeFlag ? 'Active' : 'Inactive' }}
                      </span>
                    </div>

                    <!-- Action Buttons Group -->
                    <div class="action-buttons-group">
                      <v-btn
                        id="button-editdocumentperchunk-uploadvector"
                        variant="text"
                        density="comfortable"
                        @click="EditVectorperChunk(item)"
                        class="action-btn-doc edit-btn"
                        icon
                        size="small"
                        v-if="!item.flagGenerateVector"
                      >
                        <v-icon size="18">{{ canEdit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                        <v-tooltip activator="parent" location="top">{{ canEdit ? 'Edit content' : 'View content' }}</v-tooltip>
                      </v-btn>

                      <!-- Action Divider -->
                      <div
                        class="action-divider"
                        v-if="canDelete && !item.flagGenerateVector"
                      ></div>

                      <v-btn
                        v-if="canDelete"
                        id="button-delete-uploadvector"
                        variant="text"
                        density="comfortable"
                        @click="DeleteById(item.id)"
                        class="action-btn-doc delete-btn"
                        icon
                        size="small"
                        :disabled="btnDisableDelete(item)"
                      >
                        <v-icon size="18">mdi-delete-outline</v-icon>
                        <v-tooltip activator="parent" location="top"> Delete item </v-tooltip>
                      </v-btn>
                    </div>
                  </div>
                </template>
              </v-data-table-server>
            </div>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-card-actions style="display: flex; align-items: flex-end; justify-content: flex-end">
                <v-btn
                  style="margin-top: 1em; text-transform: capitalize; color: #9a9a9a; border-radius: 16px"
                  @click="DeleteByName(searchVectorDBName2)"
                  v-if="canDelete && showTable == true"
                  :disabled="dataAll == 0 || isDocumentNotMine"
                  prepend-icon="mdi-refresh"
                  >{{ 'Clear' }}</v-btn
                >

                <v-btn
                  id="button-close-uploadvector"
                  class="ml-3 mt-3"
                  style="margin-left: 1em; border-radius: 16px; background: #faa91b; width: 89.863px; text-transform: capitalize; color: #fff"
                  to="/VectorManagement"
                  >Close</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-flex>
      </div>
    </v-container>
    <v-dialog ref="form" v-model="EditVector" persistent max-width="700px" class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon class="header-icon">{{ canEdit ? 'mdi-pencil' : 'mdi-eye-outline' }}</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h3 class="dialog-title">{{ canEdit ? 'Edit Vector Content' : 'View Vector Content' }}</h3>
              <p class="dialog-subtitle">{{ canEdit ? 'Modify your document content' : 'View your document content' }}</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" size="small" @click="closeUploaddialog" class="close-button" color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="edit-content">
          <v-form ref="form" lazy-validation :disabled="!canEdit">
            <div class="textarea-wrapper">
              <label class="textarea-label">Content</label>
              <v-textarea
                id="textORG-textarea-popupedit-uploadvector"
                v-model="Edit.textORG"
                variant="outlined"
                auto-grow
                rows="12"
                counter
                required
                :readonly="isViewOnly"
                placeholder="Enter your content here..."
                class="content-textarea"
              >
              </v-textarea>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn id="button-closeedit-popupedit-uploadvector" variant="outlined" color="grey-darken-1" @click="closeUploaddialog" class="dialog-action-btn cancel-btn">
            <v-icon start>mdi-close</v-icon>
            {{ $t('close') }}
          </v-btn>
          <v-btn v-if="canEdit" id="button-saveedit-popupedit-uploadvector" variant="elevated" @click="SaveEdit()" class="dialog-action-btn save-btn-edit">
            <v-icon start>mdi-content-save</v-icon>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- add dialog -->
    <v-dialog ref="form" v-model="AddVector" max-width="800px" class="modern-dialog">
      <v-card class="dialog-card">
        <v-card-title class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon class="header-icon">mdi-plus-circle</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h3 class="dialog-title">Add Vector Content</h3>
              <p class="dialog-subtitle">Create new document content</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" color="white" @click="closeUploaddialogAdd" class="close-button">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="add-content">
          <v-form ref="form" lazy-validation>
            <div class="textarea-wrapper">
              <label class="textarea-label">Content</label>
              <v-textarea
                id="textORG-textarea-popupadd-uploadvector"
                v-model="Add.textORG"
                variant="outlined"
                auto-grow
                rows="15"
                counter
                required
                placeholder="Enter your content here..."
                class="content-textarea"
              >
              </v-textarea>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <div class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left"></div>
            <div class="actions-right">
              <v-btn variant="outlined" color="grey-darken-1" @click="closeUploaddialogAdd" class="dialog-action-btn cancel-btn">
                <v-icon start>mdi-close</v-icon>
                {{ $t('close') }}
              </v-btn>
              <v-btn v-if="canAdd" id="button-saveadd-popupadd-uploadvector" variant="elevated" @click="SaveAdd()" class="dialog-action-btn save-btn-add">
                <v-icon start>mdi-content-save</v-icon>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-overlay :model-value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card class="loading-card">
          <v-card-text class="text-center pa-6">
            <v-progress-circular indeterminate color="primary" size="64" class="mb-4"> </v-progress-circular>
            <div class="text-h6">Loading Please Wait...</div>
            <v-progress-linear indeterminate color="primary" class="mt-4"> </v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>

    <v-dialog v-model="TemplateVector" max-width="900px" persistent>
      <v-card class="template-dialog">
        <v-card-title class="template-header">
          <div class="header-content">
            <v-icon class="header-icon">mdi-file-download-outline</v-icon>
            <div class="header-text">
              <h2 class="dialog-title">Template Vector</h2>
              <p class="dialog-subtitle">Download template files for different document types</p>
            </div>
          </div>
          <v-btn icon variant="text" size="small" @click="TemplateVector = false" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="template-content">
          <div class="template-description">
            <v-alert type="info" variant="tonal" class="mb-4" density="compact">
              <template v-slot:prepend>
                <v-icon>mdi-information-outline</v-icon>
              </template>
              <div class="alert-content">
                <strong>How to use templates:</strong>
                <ul class="template-instructions">
                  <li>Select the appropriate template for your document type</li>
                  <li>Download the template file format you prefer</li>
                  <li>Fill in your data following the template structure</li>
                  <li>Upload the completed file using the upload section above</li>
                </ul>
              </div>
            </v-alert>
          </div>

          <div class="template-table-wrapper">
            <v-data-table :items="dataTemplate" :headers="enhancedHeadersTemplate" loading-text="Loading..." hide-default-footer disable-sort class="template-table" density="comfortable">
              <template v-slot:item="{ item }">
                <tr class="template-row">
                  <!-- Mode Type Column -->
                  <td class="mode-type-cell">
                    <div class="mode-type-content">
                      <span :color="getModeTypeColor(item.modeType)" variant="elevated" size="small" class="mode-chip">
                        {{ item.modeType }}
                      </span>

                      <v-tooltip v-if="item.modeType == 'CustomSplit'" location="right" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="small" color="warning" class="info-icon"> mdi-information </v-icon>
                        </template>
                        <div class="custom-tooltip">
                          <strong>CustomSplit Template:</strong><br />
                          Use "||!" as separator<br />
                          Example: SplitChunkContent
                        </div>
                      </v-tooltip>
                    </div>
                  </td>

                  <!-- CSV Column -->
                  <td class="download-cell">
                    <template v-if="item.modeType != 'CustomSplit' && item.modeType != 'Article'">
                      <v-btn :id="item.modeType + '_CSV'" variant="elevated" color="success" size="small" class="download-btn" @click="linkDownload(item.modeType, item.CSV)">
                        <v-icon start>mdi-file</v-icon>
                        CSV
                        <v-tooltip activator="parent" location="top"> Download {{ item.modeType }} - CSV Template </v-tooltip>
                      </v-btn>
                    </template>
                    <div v-else class="not-available">
                      <v-icon color="grey-lighten-2">mdi-minus</v-icon>
                    </div>
                  </td>

                  <!-- Excel Columns -->
                  <td class="download-cell">
                    <template v-if="item.modeType != 'CustomSplit' && item.modeType != 'Article'">
                      <div class="excel-buttons">
                        <v-btn
                          v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'"
                          :id="item.modeType + '_Excel'"
                          variant="elevated"
                          color="green"
                          size="small"
                          class="download-btn excel-btn"
                          @click="linkDownload(item.modeType, item.Excel)"
                        >
                          <v-icon start>mdi-file-excel</v-icon>
                          Excel
                          <v-tooltip activator="parent" location="top"> Download {{ item.modeType }} - Excel Template </v-tooltip>
                        </v-btn>

                        <v-btn
                          :id="item.modeType + '_ExcelMultiColumn'"
                          variant="elevated"
                          color="teal"
                          size="small"
                          class="download-btn excel-multi-btn"
                          @click="linkDownload(item.modeType, item.ExcelMultiColumn)"
                        >
                          <v-icon start>mdi-file-excel-box</v-icon>
                          Multi-Col
                          <v-tooltip activator="parent" location="top"> Download {{ item.modeType }} - Excel (Multiple Columns) Template </v-tooltip>
                        </v-btn>
                      </div>
                    </template>
                    <div v-else class="not-available">
                      <v-icon color="grey-lighten-2">mdi-minus</v-icon>
                    </div>
                  </td>

                  <!-- PDF Column -->
                  <td class="download-cell">
                    <template v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn :id="item.modeType + '_PDF'" variant="elevated" color="red" size="small" class="download-btn" @click="linkDownload(item.modeType, item.PDF)">
                        <v-icon start>mdi-file-pdf-box</v-icon>
                        PDF
                        <v-tooltip activator="parent" location="top"> Download {{ item.modeType }} - PDF Template </v-tooltip>
                      </v-btn>
                    </template>
                    <div v-else class="not-available">
                      <v-icon color="grey-lighten-2">mdi-minus</v-icon>
                    </div>
                  </td>

                  <!-- Word Column -->
                  <td class="download-cell">
                    <template v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn :id="item.modeType + '_Word'" variant="elevated" color="blue" size="small" class="download-btn" @click="linkDownload(item.modeType, item.Word)">
                        <v-icon start>mdi-file-word</v-icon>
                        Word
                        <v-tooltip activator="parent" location="top"> Download {{ item.modeType }} - Word Template </v-tooltip>
                      </v-btn>
                    </template>
                    <div v-else class="not-available">
                      <v-icon color="grey-lighten-2">mdi-minus</v-icon>
                    </div>
                  </td>

                  <!-- PowerPoint Column -->
                  <td class="download-cell">
                    <template v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn :id="item.modeType + '_PowerPoint'" variant="elevated" color="orange" size="small" class="download-btn" @click="linkDownload(item.modeType, item.PowerPoint)">
                        <v-icon start>mdi-file-powerpoint</v-icon>
                        PPT
                        <v-tooltip activator="parent" location="top"> Download {{ item.modeType }} - PowerPoint Template </v-tooltip>
                      </v-btn>
                    </template>
                    <div v-else class="not-available">
                      <v-icon color="grey-lighten-2">mdi-minus</v-icon>
                    </div>
                  </td>

                  <!-- Text Column -->
                  <td class="download-cell">
                    <template v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn :id="item.modeType + '_Text'" variant="elevated" color="grey-darken-1" size="small" class="download-btn" @click="linkDownload(item.modeType, item.Text)">
                        <v-icon start>mdi-file-document</v-icon>
                        TXT
                        <v-tooltip activator="parent" location="top"> Download {{ item.modeType }} - Text Template </v-tooltip>
                      </v-btn>
                    </template>
                    <div v-else class="not-available">
                      <v-icon color="grey-lighten-2">mdi-minus</v-icon>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="template-actions">
          <v-spacer></v-spacer>
          <v-btn variant="elevated" color="red" @click="TemplateVector = false" class="close-action-btn">
            <v-icon start>mdi-close</v-icon>
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ><v-dialog v-model="Detaildialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2" style="margin-bottom: 1rem; position: sticky; top: 0px; z-index: 1">
          {{ tempTitle }}
        </v-card-title>
        <v-card-text>
          <span style="margin-right: 1rem" v-html="formatText(tempText)"></span>
        </v-card-text>
      </v-card>
    </v-dialog>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2" style="margin-bottom: 1rem; position: sticky; top: 0px; z-index: 1">
          {{ tempTitle }}
        </v-card-title>
        <v-card-text>
          <span style="margin-right: 1rem" v-html="formatText(tempText)"></span>
        </v-card-text>
      </v-card> -->
  </div>
</template>
<script>
import DragDropFile from '@/components/DragDropFile.vue';
import generalImg from '@/assets/images/Group 11.svg';
import maxCharacterImg from '@/assets/images/Group 12.svg';
import customSplitImg from '@/assets/images/Group 13.svg';
import articleImg from '@/assets/images/Group 13.svg';
import headerAllChunkImg from '@/assets/images/Group 11.svg';
import headerFirstChunkImg from '@/assets/images/Group 12.svg';
import wordImageImg from '@/assets/images/Group 12.svg';
import pdfImageImg from '@/assets/images/Group 12.svg';
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
import TemplateSVG from '@/assets/images/purple_download.svg';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import { useDisplay } from 'vuetify';
import LogTrace from '@/api/function.js';
import MarkdownRenderer from '@/components/MarkdownRenderer.vue';

export default {
  name: 'UploadVector',
  mixins: [LogTrace],
  components: { DragDropFile, VueDatePicker, MarkdownRenderer },
  props: ["id"],
  inject : [
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  setup() {
    const { smAndUp } = useDisplay();

    return {
      smAndUp,
    };
  },
  data: () => ({
    templateIcon: TemplateSVG,

    uploadDialog: false,
    checkbox1: false,
    actionEdit: false,
    TemplateVector: false,
    dialog: false,
    loadingTable: false,
    EditVector: false,
    errors: {
      doctypeError: null,
      vectortypeError: null,
      modelTypeError: null,
    },
    Edit: {
      id: null,
      textORG: null,
    },
    AddVector: false,
    flagNew: true,
    Add: {
      id: null,
      textORG: null,
    },
    loading: true,
    today: null,
    searchVectorDBName: null,
    searchVectorDBName2: null,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
      deleteAll: false,
      groupReplaceID: null,
      customCharacter: null,
      DetectLanguage: true,
      MaxLimitedCharacter: null,
      PersonalInfo: false,
      effectiveStartDate: null,
      effectiveEndDate: null,
      knowledgeType: null,
      activeStatus: true,
      Title: null,
      SubTitle: null,
      chunkOverlapChars: 0,
    },
    searchtext_org: null,
    modelType: null,
    doctype: null,
    vectortype: null,
    tempgroupReplaceID: null,
    options: {},
    options2: {},
    DDModel: [],
    files: [],
    dataTable: [],
    dataTable2: [],
    uploadedFiles: [],
    DDGroupReplace: [],
    filterdatavectortype: [],
    filterDDType: [],
    DDType: [
      {
        id: 'General',
        name: 'General',
        value: 1,
        image: generalImg,
      },
      {
        id: 'MaxCharacter',
        name: 'MaxCharacter',
        value: 2,
        image: maxCharacterImg,
      },
      {
        id: 'CustomSplit',
        name: 'CustomSplit',
        value: 3,
        image: customSplitImg,
      },
      {
        id: 'Article',
        name: 'Article',
        value: 4,
        image: articleImg,
      },
      {
        id: 'HeaderAllChunk',
        name: 'HeaderAllChunk',
        value: 5,
        image: headerAllChunkImg,
      },
      {
        id: 'HeaderFirstChunk',
        name: 'HeaderFirstChunk',
        value: 6,
        image: headerFirstChunkImg,
      },
      {
        id: 'WordImage',
        name: 'WordImage',
        value: 7,
        image: wordImageImg,
      },
      {
        id: 'PDFImage',
        name: 'PDFImage',
        value: 8,
        image: pdfImageImg,
      },
      {
        id: 'ContextByLLM',
        name: 'Context by LLM',
        value: 10,
        image: generalImg,  // Reuse general image for now
      },
      {
        id: 'MDCustomSplit',
        name: 'MD Custom Split',
        value: 11,
        image: customSplitImg,
      },
    ],
    knowledgeCategories: [
      { id: 'promotion', name: 'Promotion', value: 1 },
      { id: 'banking_service', name: 'Banking Service', value: 2 },
      { id: 'product_insurance', name: 'Product Insurance', value: 3 },
      { id: 'customer_support', name: 'Customer Support', value: 4 },
      { id: 'investment_advisory', name: 'Investment Advisory', value: 5 },
    ],
    datadoctype: [
      { id: 'Auto', name: 'Auto', value: 9 },
      { id: 'Csv', name: 'CSV', value: 1 },
      { id: 'Excel', name: 'Excel', value: 2 },
      { id: 'Pdf', name: 'PDF', value: 3 },
      { id: 'Word', name: 'Word', value: 4 },
      { id: 'Text', name: 'Text', value: 5 },
      { id: 'Powerpoint', name: 'PowerPoint', value: 6 },
    ],
    datavectortype: [
      { id: 'General', name: 'General', value: 1 },
      { id: 'Article', name: 'Article', value: 2 },
      { id: 'PriceList', name: 'PriceList', value: 3 },
      { id: 'MD', name: 'MD', value: 4 },
    ],
    // Title/SubTitle dropdown options for Context by LLM mode
    titleOptions: [
      { id: 'Product', name: 'Product', value: 'Product' },
      { id: 'ServiceInfo', name: 'ServiceInfo', value: 'ServiceInfo' },
      { id: 'Financial_Transaction', name: 'Financial_Transaction', value: 'Financial_Transaction' },
      { id: 'Promotion', name: 'Promotion', value: 'Promotion' },
      { id: 'Contact_Agent', name: 'Contact_Agent', value: 'Contact_Agent' },
      { id: 'Family_Banking', name: 'Family_Banking', value: 'Family_Banking' },
      { id: 'Troubleshooting', name: 'Troubleshooting', value: 'Troubleshooting' },
      { id: 'Greeting', name: 'Greeting', value: 'Greeting' },
      { id: 'Non_Banking', name: 'Non_Banking', value: 'Non_Banking' },
      { id: 'Triage_Agent', name: 'Triage_Agent', value: 'Triage_Agent' },
    ],
    titleSubTitleMap: {
      'Product': ['Deposit', 'Loan', 'Insurance', 'Card', 'Calc'],
      'ServiceInfo': ['Service_Info', 'Page_Navigation', 'Branch_Navigation'],
      'Financial_Transaction': ['Transfer', 'TopUp', 'Paybill'],
      'Promotion': [],
      'Contact_Agent': [],
      'Family_Banking': [],
      'Troubleshooting': [],
      'Greeting': [],
      'Non_Banking': [],
      'Triage_Agent': [],
    },
    dataTemplate: [
      {
        modeType: 'General',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
      {
        modeType: 'MaxCharacter',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
      {
        modeType: 'CustomSplit',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
      {
        modeType: 'Article',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
      {
        modeType: 'HeaderAllChunk',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
      {
        modeType: 'HeaderFirstChunk',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
    ],
    modeType: [
      {
        name: 'Add',
        value: false,
      },
      {
        name: 'Replace',
        value: true,
      },
    ],
    isSearch: false,
    isSearch2: false,
    isFirst: true,
    isFirst2: true,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,

    searchTotalTable2: 0,
    itemsPerPage2: 10,
    showTable: true,
    dataUpdate: -1,
    dataAll: 0,
    exceptionFlag: false,
    vectornameDuplicate: false,
    VectorDBNameDuplicate: '',
    DisabledBtn: false,
    // Default accept all supported file types for the new flow
    accept: '.md, .html, .htm, .json, .csv, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .png, .jpg, .jpeg, .gif, .bmp, .tiff, .tif, .webp, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, text/html, application/json, image/png, image/jpeg, image/gif, image/bmp, image/tiff, image/webp',
    rules: {
      required: (value) => !!value || 'Required.',
      // required2 : this.vectornameDuplicate || 'dup'
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    ShowAllText: false,
    CheckboxShowAllText: false,
    CheckboxShowMarkdown: false,
    tempTitle: '',
    tempText: '',
    showConfigSection: false,
    configLoading: false,
    configForm: {
      MaxLimitedCharacter: null,
      effectiveStartDate: null,
      effectiveEndDate: null,
      DetectLanguage: true,
      PersonalInfo: false,
      activeStatus: true,
      knowledgeType: null,
      Title: null,
      SubTitle: null,
      chunkOverlapChars: 0,
    },
    needsReprocessing: false,
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('UploadVector');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('UploadVector'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('UploadVector'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('UploadVector'));
    },
    // Mirror the backend permission rule (CheckUserPermissionVectorDBName):
    // a "User" role (RoleId=2) can only delete documents they created themselves.
    // Disable the document-level "Clear" button up-front so they don't get rejected
    // after the confirm dialog. Uses the first loaded chunk's createBy because all
    // chunks under the same vectorDBName share the same creator.
    isDocumentNotMine() {
      if (this.RoleId != 2) return false;
      if (!this.dataTable2 || this.dataTable2.length === 0) return false;
      return this.dataTable2[0].createBy != this.Username;
    },
    // Filter Process Type options by permission:
    //   - 'Add'    (deleteAll=false) requires canAdd OR canEdit (edit implies the ability to add)
    //   - 'Replace' (deleteAll=true)  requires canEdit only (destructive — wipes existing data)
    filteredModeType() {
      const result = [];
      for (const opt of this.modeType) {
        if (opt.value === false && (this.canAdd || this.canEdit)) result.push(opt);
        else if (opt.value === true && this.canEdit) result.push(opt);
      }
      return result;
    },
    // Check if file is selected
    isFileSelected() {
      return this.uploadedFiles && this.uploadedFiles.length > 0;
    },
    // Check if MD VectorType is selected
    isMDMode() {
      return this.vectortype && this.vectortype.value === 4;
    },
    // Auto mode is MD + Context by LLM / MD Custom Split OR old doctype Auto (value 9)
    isAutoMode() {
      return (this.isMDMode && (this.requestVector.modelType == 10 || this.requestVector.modelType == 11)) || (this.doctype && this.doctype.value == 9);
    },
    // Show Title/SubTitle dropdowns when MD mode AND either Context by LLM or MD Custom Split is selected
    showTitleSubTitle() {
      return this.isMDMode && (this.requestVector.modelType == 10 || this.requestVector.modelType == 11);
    },
    // Get available sub-titles based on selected title
    availableSubTitles() {
      if (!this.requestVector.Title) return [];
      const subTitles = this.titleSubTitleMap[this.requestVector.Title] || [];
      return subTitles.map(st => ({ id: st, name: st, value: st }));
    },
    // Get available sub-titles for config form based on selected title
    configAvailableSubTitles() {
      if (!this.configForm.Title) return [];
      const subTitles = this.titleSubTitleMap[this.configForm.Title] || [];
      return subTitles.map(st => ({ id: st, name: st, value: st }));
    },
    // Check if Context by LLM is selected (modelType 10)
    isContextByLLM() {
      return this.requestVector.modelType == 10;
    },
    // Check if MD Custom Split is selected (modelType 11 in UI, 10 in backend)
    isMDCustomSplit() {
      return this.requestVector.modelType == 11;
    },
    // Show Title/SubTitle/ChunkOverlap in config section when:
    // 1. Context by LLM is selected, OR
    // 2. API returned values for Title/SubTitle/ChunkOverlap (editing existing document)
    showConfigTitleSubTitle() {
      const hasTitle = this.configForm.Title != null && this.configForm.Title !== '';
      const hasSubTitle = this.configForm.SubTitle != null && this.configForm.SubTitle !== '';
      const hasChunkOverlap = this.configForm.chunkOverlapChars != null && this.configForm.chunkOverlapChars > 0;
      const hasExistingValues = hasTitle || hasSubTitle || hasChunkOverlap;
      return this.isContextByLLM || this.isMDCustomSplit || hasExistingValues;
    },
    // Title is required when Context by LLM or MD Custom Split is selected
    isTitleRequired() {
      return this.isContextByLLM || this.isMDCustomSplit;
    },
    // SubTitle is required when Context by LLM or MD Custom Split is selected AND subtitles are available
    isSubTitleRequired() {
      return (this.isContextByLLM || this.isMDCustomSplit) && this.configAvailableSubTitles.length > 0;
    },
    enhancedHeadersTemplate() {
      return [
        {
          title: 'Processing Type',
          key: 'modeType',
          align: 'center',
          width: '160px',
          sortable: false,
        },
        {
          title: 'CSV',
          key: 'csv',
          align: 'center',
          width: '100px',
          sortable: false,
        },
        {
          title: 'Excel',
          key: 'excel',
          align: 'center',
          width: '140px',
          sortable: false,
        },
        {
          title: 'PDF',
          key: 'pdf',
          align: 'center',
          width: '100px',
          sortable: false,
        },
        {
          title: 'Word',
          key: 'word',
          align: 'center',
          width: '100px',
          sortable: false,
        },
        {
          title: 'PowerPoint',
          key: 'powerpoint',
          align: 'center',
          width: '120px',
          sortable: false,
        },
        {
          title: 'Text',
          key: 'text',
          align: 'center',
          width: '100px',
          sortable: false,
        },
      ];
    },
    headers2() {
      return [
        {
          title: this.$t('no'),
          key: 'number',
          align: 'center',
          sortable: false,
          width: this.smAndUp ? '60px' : '30px',
        },
        {
          title: 'text_org',
          key: 'textORG',
          align: 'center',
          sortable: true,
          width: this.smAndUp ? '40%' : '300px',
        },
        {
          title: 'text_en',
          key: 'textEN',
          align: 'center',
          sortable: true,
          width: this.smAndUp ? '40%' : '300px',
        },
        {
          title: this.$t('manage'),
          key: 'actions',
          align: 'center',
          sortable: false,
          width: this.smAndUp ? '15%' : 'auto',
        },
      ];
    },
    headersTemplate() {
      return [
        { text: 'Type', align: 'center', width: '25%' },
        { text: 'CSV', align: 'center' },
        { text: 'Excel', align: 'center' },
        { text: 'PDF', align: 'center' },
        { text: 'Word', align: 'center' },
        { text: 'PowerPoint', align: 'center' },
        { text: 'Text', align: 'center' },
      ];
    },
  },
  watch: {
    // Keep deleteAll in sync with filtered Process Type options:
    //   - empty list (no canAdd & no canEdit) → null, dropdown disabled
    //   - current value not allowed              → snap to first allowed value
    filteredModeType: {
      immediate: true,
      handler(newVal) {
        if (!newVal || newVal.length === 0) {
          if (this.requestVector) this.requestVector.deleteAll = null;
        } else if (this.requestVector && !newVal.some(o => o.value === this.requestVector.deleteAll)) {
          this.requestVector.deleteAll = newVal[0].value;
        }
      },
    },
    options2: {
      handler() {
        if (this.refreshTimeout) {
          clearTimeout(this.refreshTimeout);
        }
        this.refreshTimeout = setTimeout(() => {
          this.ReFresh();
        }, 300);
      },
      deep: true,
    },
    requestVector: {
      handler(newVal) {
        // CustomCharacter is used by legacy CustomSplit (3) and MD Custom Split (11)
        if (newVal.modelType != 3 && newVal.modelType != 11) {
          this.requestVector.customCharacter = null;
        }
        // Title/SubTitle apply to Context by LLM (10) and MD Custom Split (11)
        if (newVal.modelType != 10 && newVal.modelType != 11) {
          this.requestVector.Title = null;
          this.requestVector.SubTitle = null;
        }
      },
      deep: true,
    },
    doctype: {
      handler(val) {
        let self = this;
        self.vectortype = null;
        self.filterDDType = [];
        self.filterdatavectortype = [];

        // Handle Auto mode - set modelType to 9 automatically
        if (val && val.value == 9) {
          console.log('[doctype watcher] Auto mode selected, setting modelType to 9');
          self.requestVector.modelType = 9;
          self.vectortype = { id: 'General', name: 'General', value: 1 };
          self.filterdatavectortype = [];
          self.filterDDType = [];
          // Clear validation errors for Auto mode
          self.errors.vectortypeError = null;
          self.errors.modelTypeError = null;
          self.setTypeFile(val);
          console.log('[doctype watcher] After setup - modelType:', self.requestVector.modelType);
          return;
        }

        if (val.value == 1 || val.value == 2) {
          self.filterdatavectortype = self.datavectortype.filter(
            (e) => e.value != 2
          );
        } else {
          self.filterdatavectortype = self.datavectortype.filter((e) => e.value != 3);
        }

        this.filterDDType = [];
        // this.vectortype = 1;
        // this.requestVector.modelType = 1;
        this.requestVector.customCharacter = null;
        // if (val == 1 || val == 2) {
        //   this.filterDDType = this.DDType.filter(e => e.value != 3);
        // } else {
        //   this.filterDDType = this.DDType;
        // }
        self.setTypeFile(val);
      },
    },
    vectortype: {
      handler(val) {
        let self = this;
        if (val) {
          this.errors.vectortypeError = null;
        }
        self.filterDDType = [];
        self.requestVector.customCharacter = null;

        // MD mode (value 4) - show Context by LLM and MD Custom Split
        if (val && val.value == 4) {
          self.filterDDType = self.DDType.filter((e) => e.value == 10 || e.value == 11);
          self.requestVector.modelType = null;
          return;
        }

        // Article mode (value 2) - show Article processing
        if (val && val.value == 2) {
          self.filterDDType = self.DDType.filter((e) => e.value == 4);
        }
        // PriceList mode (value 3) - show HeaderAllChunk and HeaderFirstChunk
        else if (val && val.value == 3) {
          self.filterDDType = self.DDType.filter(
            (e) => e.value == 5 || e.value == 6
          );
        }
        // General mode (value 1) - show General, MaxCharacter, CustomSplit
        else if (val && val.value == 1) {
          self.filterDDType = self.DDType.filter(
            (e) => e.value == 1 || e.value == 2 || e.value == 3
          );
        }
        // Fallback - show basic options
        else {
          self.filterDDType = self.DDType.filter((e) => e.value == 1 || e.value == 2 || e.value == 3);
        }

        // Reset modelType when vectortype changes
        self.requestVector.modelType = null;
      },
      'requestVector.modelType'(val) {
        if (val) {
          this.errors.modelTypeError = null;
        }
      },
    },
    CheckboxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
  },
  methods: {
    syncConfigForm() {
      this.configForm.MaxLimitedCharacter = this.requestVector.MaxLimitedCharacter;
      this.configForm.effectiveStartDate = this.requestVector.effectiveStartDate;
      this.configForm.effectiveEndDate = this.requestVector.effectiveEndDate;
      this.configForm.DetectLanguage = this.requestVector.DetectLanguage;
      this.configForm.PersonalInfo = this.requestVector.PersonalInfo;
      this.configForm.activeStatus = this.requestVector.activeStatus ?? true;
      this.configForm.knowledgeType = this.requestVector.knowledgeType;
      this.configForm.Title = this.requestVector.Title;
      this.configForm.SubTitle = this.requestVector.SubTitle;
      this.configForm.chunkOverlapChars = this.requestVector.chunkOverlapChars ?? 0;
    },
    onConfigTitleChange() {
      this.configForm.SubTitle = null; // Clear subtitle when title changes
    },
    btnDisableDelete(item) {
      if (this.RoleId == 2 && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    getModeTypeColor(modeType) {
      const colorMap = {
        General: 'blue',
        MaxCharacter: 'green',
        CustomSplit: 'orange',
        Article: 'purple',
        HeaderAllChunk: 'teal',
        HeaderFirstChunk: 'cyan',
      };
      return colorMap[modeType] || 'grey';
    },
    validateDateRange() {
      // Validate that end date is greater than start date
      const self = this;

      if (self.requestVector.effectiveStartDate && self.requestVector.effectiveEndDate) {
        if (self.requestVector.effectiveEndDate <= self.requestVector.effectiveStartDate) {
          self.$toast.error('Effective End Date must be greater than Effective Start Date');
          return false;
        }
      }

      return true;
    },
    toLocalDateString(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // Format date for API submission using local timezone (not UTC)
    // This prevents timezone offset issues when user types/selects a date
    formatDateForAPI(dateValue) {
      if (!dateValue) return null;
      const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
      if (isNaN(d.getTime())) return null;
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // Parse date from API response to yyyy-MM-dd string format for VueDatePicker
    parseDateFromAPI(dateString) {
      if (!dateString) return null;
      // API returns ISO string like "2026-01-02T00:00:00" or "2026-01-02"
      // Extract just the date part yyyy-MM-dd
      if (typeof dateString === 'string') {
        return dateString.substring(0, 10);
      }
      // If it's a Date object, format it
      const d = new Date(dateString);
      if (isNaN(d.getTime())) return null;
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    prepareRequestData() {
      // Prepare data for API submission
      const self = this;

      // Validate date range first
      if (!self.validateDateRange()) {
        return null; // Return null if validation fails
      }

      // Create a copy of requestVector for API submission without modifying original dates
      const apiData = { ...self.requestVector };

      // MD + Context by LLM v1 mode: use Auto pipeline (backend EmbedTypeVector.Auto = 9)
      if (self.isMDMode && self.requestVector.modelType == 10) {
        apiData.modelType = 9;
        console.log('[prepareRequestData] MD + Context by LLM mode: setting modelType to 9 (Auto)');
      }
      // MD + Custom Split mode: use MDCustomSplit pipeline (backend EmbedTypeVector.MDCustomSplit = 10)
      else if (self.isMDMode && self.requestVector.modelType == 11) {
        apiData.modelType = 10;
        console.log('[prepareRequestData] MD + Custom Split mode: setting modelType to 10 (MDCustomSplit)');
      }

      if (self.configForm.effectiveStartDate) {
        // Use local date format to prevent timezone offset issues
        apiData.effectiveStartDate = self.formatDateForAPI(self.configForm.effectiveStartDate);
      }

      if (self.configForm.effectiveEndDate) {
        // Use local date format to prevent timezone offset issues
        apiData.effectiveEndDate = self.formatDateForAPI(self.configForm.effectiveEndDate);
      }

      // Prepare groupReplaceID as JSON string
      apiData.groupReplaceID = self.tempgroupReplaceID == null ? null : JSON.stringify(self.tempgroupReplaceID);

      // Create FormData for [FromForm] backend
      const formData = new FormData();

      // Add the file with original field name
      if (self.requestVector.entity) {
        if (self.requestVector.entity instanceof FormData) {
          const file = self.requestVector.entity.get('entity');
          formData.append('entity', file);
        } else {
          formData.append('entity', self.requestVector.entity);
        }
      }

      // Add all form parameters using apiData for dates
      // Use apiData.modelType which may be modified for MD + Context by LLM mode
      formData.append('modelType', apiData.modelType || '');
      formData.append('vectordbName', self.requestVector.vectordbName || '');
      formData.append('deleteAll', self.requestVector.deleteAll || false);
      formData.append('DetectLanguage', self.requestVector.DetectLanguage || false);
      formData.append('MaxLimitedCharacter', self.requestVector.MaxLimitedCharacter || '');

      if (self.requestVector.customCharacter != null) {
        formData.append('customCharacter', self.requestVector.customCharacter);
      }
      if (apiData.groupReplaceID != null) {
        formData.append('groupReplaceID', apiData.groupReplaceID);
      }

      // Add new fields using apiData for properly formatted dates
      if (apiData.effectiveStartDate != null) {
        formData.append('effectiveStartDate', apiData.effectiveStartDate);
      }
      if (apiData.effectiveEndDate != null) {
        formData.append('effectiveEndDate', apiData.effectiveEndDate);
      }
      if (self.requestVector.knowledgeType != null) {
        formData.append('KnowledgeCategory', self.requestVector.knowledgeType);
      }
      if (self.requestVector.activeStatus != null) {
        formData.append('activeStatus', self.requestVector.activeStatus);
      }
      if (self.requestVector.PersonalInfo != null) {
        formData.append('PersonalInfo', self.requestVector.PersonalInfo);
      }

      // Add Title and SubTitle for Context by LLM mode (from configForm)
      if (self.configForm.Title != null) {
        formData.append('Title', self.configForm.Title);
      }
      if (self.configForm.SubTitle != null) {
        formData.append('SubTitle', self.configForm.SubTitle);
      }

      // Add chunk overlap for Context by LLM mode (from configForm)
      formData.append('chunkOverlapChars', self.configForm.chunkOverlapChars || 0);

      return formData;
    },
    // Date handling methods
    onStartDateChange(selectedDate) {
      if (selectedDate) {
        this.requestVector.effectiveStartDate = selectedDate;

        // Clear end date if it's before the new start date
        if (this.requestVector.effectiveEndDate && this.requestVector.effectiveEndDate < selectedDate) {
          this.requestVector.effectiveEndDate = null;
        }
      }
    },
    onEndDateChange(selectedDate) {
      if (selectedDate) {
        this.requestVector.effectiveEndDate = selectedDate;
      }
    },
    // Clear SubTitle when Title changes
    onTitleChange(newTitle) {
      this.requestVector.SubTitle = null;
    },
    formatDateForDisplay(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatDateTimeForDisplay(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${day}/${month}/${year}\n${hours}:${minutes}:${seconds}`;
    },

    getLocalDateTimeWithOffset(dateStr) {
      if (!dateStr) return null;

      const [year, month, day] = dateStr.trim().split('-').map(Number);

      // Create a proper Date object with current time
      const now = new Date();
      const localDateTime = new Date(year, month - 1, day, now.getHours(), now.getMinutes(), now.getSeconds());

      // Convert to UTC ISO string (this will work for all timezones)
      const utcString = localDateTime.toISOString();

      return utcString; // Returns format like "2025-08-05T11:57:48.000Z"
    },

    // getLocalDateTimeWithOffset(dateStr) {
    //   // For DateTimeOffset: Use local time with timezone offset
    //   const now = new Date();

    //   // Get local time parts (user's actual local time)
    //   const localHours = now.getHours().toString().padStart(2, '0');
    //   const localMinutes = now.getMinutes().toString().padStart(2, '0');
    //   const localSeconds = now.getSeconds().toString().padStart(2, '0');

    //   // Get timezone offset in minutes
    //   const timezoneOffset = now.getTimezoneOffset();

    //   // Calculate sign and absolute offset
    //   const offsetSign = timezoneOffset <= 0 ? '+' : '-';
    //   const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60)
    //     .toString()
    //     .padStart(2, '0');
    //   const offsetMinutes = (Math.abs(timezoneOffset) % 60).toString().padStart(2, '0');

    //   const offsetString = `${offsetSign}${offsetHours}:${offsetMinutes}`;

    //   // Combine date, local time and offset
    //   const dateTimeStr = `${dateStr}T${localHours}:${localMinutes}:${localSeconds}${offsetString}`;

    //   return dateTimeStr;
    // },
    handleOptionsUpdate(options) {
      this.options2 = options;
    },
    formatText(text) {
      // ๝ปลงช่องว่างเป็น &nbsp; เพื่อให้รัฝษาช่องว่างได้
      if (text) {
        return text.replace(/ /g, '&nbsp;');
      }
      return '-';
    },
    formatMarkdownText(text) {
      // Convert literal \n strings to actual newlines for markdown rendering
      if (text) {
        return text.replace(/\\n/g, '\n');
      }
      return '-';
    },

    numericKey: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleKeypress(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      // ฝำหนด Regular Expression สำหรับตรวจสอบตัวอัฝษรไทย, อังฝฤษ, ตัวเลข, เครื่องหมายขีด ๝ละเครื่องหมายขีดล่าง
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F\-_]+$/;

      if (!validCharactersRegex.test(String.fromCharCode(charCode))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handlePaste(evt) {
      // รับข้อความจาฝ clipboard
      const clipboardData = evt.clipboardData || window.clipboardData;
      let pastedText = clipboardData.getData('text');

      // ฝรองเฉพาะตัวอัฝษรที่อนุฝาตเท่านั้น (รวมเครื่องหมายขีด ๝ละเครื่องหมายขีดล่าง)
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F\-_]+$/;
      let filteredText = '';

      // วนลูปตรวจสอบ๝ต่ละตัวอัฝษรในข้อความที่วาง
      for (let i = 0; i < pastedText.length; i++) {
        const char = pastedText.charAt(i);
        if (validCharactersRegex.test(char)) {
          filteredText += char;
        }
      }

      // ป้องฝันฝารดำเนินฝารปฝติของฝารวาง
      evt.preventDefault();

      // นำข้อความที่ผ่านฝารฝรอง๝ล้วมาต่อฝับข้อความเดิม
      const cursorPos = evt.target.selectionStart;
      const textBeforeCursor = this.searchVectorDBName2 ? this.searchVectorDBName2.substring(0, cursorPos) : '';
      const textAfterCursor = this.searchVectorDBName2 ? this.searchVectorDBName2.substring(cursorPos) : '';

      // อัปเดตค่าใน v-model
      this.searchVectorDBName2 = textBeforeCursor + filteredText + textAfterCursor;

      // เลื่อน cursor ไปยังตำ๝หน่งหลังข้อความที่วาง
      this.$nextTick(() => {
        evt.target.selectionStart = evt.target.selectionEnd = cursorPos + filteredText.length;
      });
    },
    checkValidate() {
      if (this.searchVectorDBName2 == '' || this.searchVectorDBName2 == null) {
        return 'Required.';
      } else if (this.VectorDBNameDuplicate == this.searchVectorDBName2) {
        return 'Duplicate';
      }
      return true;
    },
    checkCustomCharacterValidate() {
      if (this.requestVector.modelType == 3 && (this.requestVector.customCharacter == '' || this.requestVector.customCharacter == null)) {
        return 'Required.';
      } else {
        this.customCharacter = null;
      }
      return true;
    },

    GetByVector() {
      let self = this;
      self.loadingTable = true;
      let { page, itemsPerPage, sortBy } = self.options2;

      // Vue 3 + Vuetify 3: ปรับฝารจัดฝาร sorting
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : null,
        name: self.$route.query.name != null ? self.$route.query.name : self.searchVectorDBName2,
        text_org: self.searchtext_org,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      
      self.$call.ReFreshVector(
        temp,
        (dataResponse) => {
          // console.log(dataResponse);
          if (dataResponse.status == 0) {
            self.dataUpdate = dataResponse.data.dataUpdate;
            self.dataAll = dataResponse.data.dataAll;
            self.exceptionFlag = dataResponse.data.exceptionFlag;
            self.searchTotalTable2 = dataResponse.data.table.total;
            self.dataTable2 = dataResponse.data.table.data;
            self.totalTable = dataResponse.data.table.total;
            self.tempgroupReplaceID = dataResponse.data.groupReplaceID;
            if (self.$route.query.name) {
              self.requestVector.customCharacter = dataResponse.data.customCharacter;
              // self.requestVector.modelType = dataResponse.data.modelType;
              self.requestVector.DetectLanguage = dataResponse.data.detectLanguage;
              self.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
              self.requestVector.PersonalInfo = dataResponse.data.personalInformation;

              // self.requestVector.modelType = dataResponse.data.modelType;
              // self.requestVector.activeStatus = dataResponse.data.activeStatus;
              // self.requestVector.knowledgeType = dataResponse.data.knowledgeCategory;
              self.requestVector.effectiveStartDate = self.parseDateFromAPI(dataResponse.data.effectiveStartDate);
              self.requestVector.effectiveEndDate = self.parseDateFromAPI(dataResponse.data.effectiveEndDate);
              self.requestVector.activeStatus = dataResponse.data.activeStatus ?? true;
              self.requestVector.knowledgeType = dataResponse.data.knowledgeCategory;

              // Populate configForm for Configuration Management Section
              self.showConfigSection = true;
              self.configForm.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
              self.configForm.effectiveStartDate = self.parseDateFromAPI(dataResponse.data.effectiveStartDate);
              self.configForm.effectiveEndDate = self.parseDateFromAPI(dataResponse.data.effectiveEndDate);
              self.configForm.DetectLanguage = dataResponse.data.detectLanguage;
              self.configForm.PersonalInfo = dataResponse.data.personalInformation;
              self.configForm.activeStatus = dataResponse.data.activeStatus ?? true;
              self.configForm.knowledgeType = dataResponse.data.knowledgeCategory;
              self.configForm.Title = dataResponse.data.title;
              self.configForm.SubTitle = dataResponse.data.subTitle;
              self.configForm.chunkOverlapChars = dataResponse.data.chunkOverlapChars ?? 0;
            }
            self.AutoRefresh();
          } else {
            self.dataTable2 = [];
            self.searchTotalTable2 = 0;
            self.totalTable = 0;
            self.actionEdit = false;
          }
          self.loadingTable = false;
          self.isSearch2 = false;
          self.isFirst2 = false;
          self.showTable = true;
          self.dataTable2.forEach((element) => {
            element.show = self.ShowAllText;
          });
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch2 = false;
          console.error(errorResource);
        }
      );
    },
    validateTypeFile(type) {
      let self = this;
      let doctype = 0;
      switch (type) {
        case 'text/csv':
          doctype = 1;
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          doctype = 2;
          break;
        case 'application/pdf':
          doctype = 3;
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          doctype = 4;
          break;
        case 'text/plain':
          doctype = 5;
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          doctype = 6;
          break;
      }
      if (self.doctype == doctype) {
        return true;
      }
      return false;
    },
    Save() {
      let self = this;
      // For Auto mode, modelType is set automatically to 9
      const modelTypeValid = self.isAutoMode ? true : !!self.requestVector.modelType;
      if (!modelTypeValid || !self.searchVectorDBName2 || !self.requestVector.entity) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      if (self.requestVector.modelType == 3 && !self.requestVector.customCharacter) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      // if (!self.validateTypeFile(self.requestVector.entity.get('entity').type)) {
      //   alert('Upload Mismatched Files');
      //   return;
      // }
      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == '' || this.requestVector.MaxLimitedCharacter == undefined) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please fill in the Custom Max Character',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      self.requestVector.vectordbName = self.searchVectorDBName2;
      // self.requestVector.vectordbName = self.searchVectorDBName2;
      // self.requestVector.eventCreate = self.flagNew;
      // self.requestVector.EventCreate = self.$route.query.name == null ? true : false;

      // Prepare request data using dedicated method
      const formData = self.prepareRequestData();

      // Check if validation failed
      if (!formData) {
        return; // Stop execution if date validation failed
      }

      self.dialog = true;

      try {
        self.$call.UploadCSV2Vector(
          formData,
          (dataResponse) => {
            // Handle success for both normal mode (data == true) and Auto mode (data.success == true)
            const isSuccess = dataResponse.status == 0 &&
              (dataResponse.data === true || (dataResponse.data && dataResponse.data.success === true));

            if (isSuccess) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.searchVectorDBName2 = self.requestVector.vectordbName;
              self.requestVector.entity = null;
              self.actionEdit = true;
              self.flagNew = false;
              self.uploadedFiles = [];
              self.GetByVector();
              this.$router.replace({
                query: { ...this.$route.query, name: self.requestVector.vectordbName }
              });
            } else if (dataResponse.status == 0 && dataResponse.data == false) {
              self.$swal.fire({
                icon: 'warning',
                title: this.$t('warningWaitProcess'),
                showConfirmButton: false,
                timer: 4000,
              });
            } else {
              self.$swal.fire({
                icon: 'warning',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    VectorOnOff(item) {
      let self = this;
      var titleAlert = item.activeFlag ? this.$t('confirmOn') : this.$t('confirmOff');
      var textAlert = item.activeFlag ? this.$t('confirmOnVectorName') : this.$t('confirmOffVectorName');
      self.$swal
        .fire({
          title: titleAlert,
          text: textAlert,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            let temp = {
              id: item.id,
              activeFlag: item.activeFlag,
            };
            self.dialog = true;
            try {
              self.$call.VectorOnOff(
                temp,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    // self.GetByVector();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  item.activeFlag = !item.activeFlag;
                  console.error(errorResource);
                }
              );
            } catch (error) {
              this.LogTrace(error, 'DeleteGroup');
            }
          } else {
            item.activeFlag = !item.activeFlag;
          }
        });
    },
    SaveEdit() {
      let self = this;
      if (!self.Edit.textORG) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      let temp = {
        ID: self.Edit.id,
        Content: self.Edit.textORG,
        MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
        groupReplaceID: self.tempgroupReplaceID == null ? null : JSON.stringify(self.tempgroupReplaceID),
        DetectLanguage: self.requestVector.DetectLanguage,
      };
      self.dialog = true;
      try {
        self.$call.SaveEditVector(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });

              self.GetByVector();
              self.closeUploaddialog();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    SaveAdd() {
      let self = this;
      self.requestVector.modelType = self.requestVector.modelType == null || !self.requestVector.modelType ? (self.modelType == null ? 1 : self.modelType) : self.requestVector.modelType;
      if (!self.Add.textORG || !self.requestVector.modelType || !self.searchVectorDBName2) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      if (self.requestVector.modelType == 3 && !self.requestVector.customCharacter) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == '' || this.requestVector.MaxLimitedCharacter == undefined) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please fill in the Custom Max Character',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      self.searchVectorDBName2 = self.searchVectorDBName2.trim();
      self.requestVector.vectordbName = self.searchVectorDBName2;
      let temp = {
        vectordbName: self.requestVector.vectordbName,
        modelType: self.requestVector.modelType,
        groupReplaceID: self.tempgroupReplaceID == null ? null : JSON.stringify(self.tempgroupReplaceID),
        Content: self.Add.textORG,
        flagNew: self.flagNew,
        customCharacter: self.requestVector.customCharacter,
        DetectLanguage: self.requestVector.DetectLanguage,
        MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
        PersonalInformation: self.requestVector.PersonalInfo,
      };
      self.dialog = true;
      try {
        self.$call.SaveAddVector(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
                allowOutsideClick: true,
                allowEscapeKey: true,
                allowEnterKey: true,
                backdrop: false,
              });
              self.showTable = true;
              self.actionEdit = true;
              self.flagNew = false;

              await this.$router.replace({
                query: { ...this.$route.query, name: self.requestVector.vectordbName },
              });

              self.GetByVector();
              self.closeUploaddialogAdd();
              self.requestVector.modelType = null;
            } else {
              self.VectorDBNameDuplicate = self.searchVectorDBName2;
              // self.searchVectorDBName2 = null;
              self.requestVector.modelType = null;
              self.$swal.fire({
                icon: "warning",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    processUpload(e) {
      // If file already picked via Pick File button, use that
      // Otherwise use the file from DragDropFile
      let filesToProcess = e;
      if (this.uploadedFiles && this.uploadedFiles.length > 0 && (!e || e.length === 0)) {
        filesToProcess = this.uploadedFiles;
      }

      // If new files from DragDropFile, update and filter VectorType
      if (e && e.length > 0) {
        this.files = e;
        this.filterVectorTypeByFile(e[0].name);
      }

      // Validate vectortype and modelType
      this.errors.vectortypeError = !this.vectortype ? 'Required.' : null;
      this.errors.modelTypeError = !this.requestVector.modelType ? 'Required.' : null;

      if (this.errors.vectortypeError || this.errors.modelTypeError) {
        return;
      }

      if (!filesToProcess || filesToProcess.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        return;
      }

      const reader = new FileReader();
      reader.readAsText(filesToProcess[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, filesToProcess);
        this.ConfirmProcess();
      };
    },
    // Upload button click - uses already picked file, calls API directly
    triggerUpload() {
      // Validate required fields
      if (!this.uploadedFiles || this.uploadedFiles.length === 0) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Please select a file first',
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      if (!this.vectortype) {
        this.errors.vectortypeError = 'Required.';
        return;
      }

      if (!this.requestVector.modelType) {
        this.errors.modelTypeError = 'Required.';
        return;
      }

      // Validate Title when Context by LLM is selected
      if (this.isContextByLLM && !this.configForm.Title) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Title is required when using Context by LLM',
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      // Validate SubTitle when Context by LLM is selected and subtitles are available
      if (this.isContextByLLM && this.configAvailableSubTitles.length > 0 && !this.configForm.SubTitle) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Sub-Title is required when using Context by LLM',
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      // Use already picked file - call ConfirmProcess directly
      this.ConfirmProcess();
    },
    // Pick File button click - opens hidden file input
    openFilePicker() {
      this.$refs.hiddenFileInput.click();
    },
    // Handle file selection from Pick File button (just stores, no API call)
    handleFilePick(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        this.files = Array.from(files);
        const formDataDoc = new FormData();
        formDataDoc.append('entity', files[0]);
        this.uploadedFiles = Array.from(files);
        this.requestVector.entity = formDataDoc;

        // Auto-filter VectorType based on file extension
        this.filterVectorTypeByFile(files[0].name);
      }
      // Reset input so same file can be selected again
      event.target.value = '';
    },
    // Filter VectorType options based on file extension (like old DocType behavior)
    filterVectorTypeByFile(fileName) {
      const ext = fileName.toLowerCase().split('.').pop();

      // CSV, Excel → General (1), PriceList (3), MD (4)
      if (ext === 'csv' || ext === 'xlsx' || ext === 'xls') {
        this.filterdatavectortype = this.datavectortype.filter(e => e.value === 1 || e.value === 3 || e.value === 4);
      }
      // PDF, Word, Text, PowerPoint → General (1), Article (2), MD (4)
      else if (ext === 'pdf' || ext === 'txt' || ext === 'docx' || ext === 'doc' || ext === 'pptx' || ext === 'ppt') {
        this.filterdatavectortype = this.datavectortype.filter(e => e.value === 1 || e.value === 2 || e.value === 4);
      }
      // All other file types (images, json, html, md, etc.) → Only MD (4)
      else {
        this.filterdatavectortype = this.datavectortype.filter(e => e.value === 4);
      }

      // Reset vectortype selection when file changes
      this.vectortype = null;
      this.requestVector.modelType = null;
      this.filterDDType = [];
    },
    ValidateCSVVector(csv, files) {
      const formDataDoc = new FormData();
      formDataDoc.append('entity', files[0]);
      this.uploadedFiles = files;
      this.requestVector.entity = formDataDoc;
    },
    ConfirmProcess() {
      let self = this;
      self.$swal
        .fire({
          icon: 'warning',
          title: this.$t('importVectorTitle'),
          // text: "คุณต้องฝารนำเข้า Vector",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.Save();
          }
        });
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName);
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit('filesUploaded', this.uploadedFiles);
    },
    DeleteByName(name) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionDocument'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteVectorDBNameByName(
                name,
                async (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.dataUpdate = 0;
                    self.dataAll = 0;
                    self.actionEdit = false;
                    self.flagNew = true;
                    self.Clear();
                    self.GetByVector();

                    // const url = new URL(window.location.href);
                    // url.searchParams.delete('name');
                    // window.history.pushState({}, '', url);
                    await this.$router.push('/VectorManagement');
                    // this.$router.replace({ query: { ...this.$route.query, name: '' } });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    DeleteById(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionDocument'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteVectorDBNameById(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                      allowOutsideClick: true,
                      allowEscapeKey: true,
                      allowEnterKey: true,
                      backdrop: false, // **สำคัฝ ถ้าไม่ต้องฝารบัง UI**
                    });
                    self.GetByVector();
                  }else if (dataResponse.status == 1) {
                    self.$swal.fire({
                      icon: "error",
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t("gotIt"),
                      confirmButtonColor: "#d33",
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    AddVectorperChunk() {
      let self = this;
      self.AddVector = true;
      self.Add.textORG = null;
    },
    EditVectorperChunk(item) {
      let self = this;
      self.EditVector = true;
      self.Edit.id = item.id;
      self.Edit.textORG = item.textORG;
      // self.closeUploaddialog();
    },

    Clear() {
      let self = this;
      self.showTable = false;

      self.requestVector.entity = null;
      self.requestVector.modelId = null;
      self.requestVector.vectordbName = null;

      self.searchVectorDBName = null;
      self.searchVectorDBName2 = null;
      self.dataTable2 = [];
      self.searchTotalTable2 = 0;
      self.totalTable = 0;

      this.$emit('back', true);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      this.today = dd + '/' + mm + '/' + yyyy;
    },

    linkDownload(modelType, filename) {
      let self = this;
      let req = {
        modelType: modelType,
        filename: filename,
      };
      self.$call.DownloadTemplateVector_Stream(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `Template_${modelType}_${filename}${self.findTypeName(filename)}`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.TemplateVector = false;
        },
        (errorResource) => {
          self.TemplateVector = false;
          console.error(errorResource);
        }
      );
    },
    findTypeName(filename) {
      let type = '';
      switch (filename) {
        case 'CSV':
          type = '.csv';
          break;
        case 'Excel':
          type = '.xlsx';
          break;
        case 'ExcelMultiColumn':
          type = '.xlsx';
          break;
        case 'PDF':
          type = '.pdf';
          break;
        case 'Word':
          type = '.docx';
          break;
        case 'Text':
          type = '.txt';
          break;
        case 'PowerPoint':
          type = '.pptx';
          break;
      }
      return type;
    },
    setTypeFile(val) {
      let self = this;

      switch (val.value) {
        case 1:
          self.accept = '.csv';
          break;
        case 2:
          self.accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          break;
        case 3:
          self.accept = 'application/pdf';
          break;
        case 4:
          self.accept = '.doc, .docx, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        case 5:
          self.accept = 'text/plain';
          break;
        case 6:
          self.accept = '.ppt, .pptx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation';
          break;
        case 9: // Auto mode - accept PDF, Word, Excel, PowerPoint, CSV, Text, Images
          self.accept = '.md, .json, .csv, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .png, .jpg, .jpeg, .gif, .bmp, .tiff, .tif, .webp, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, image/png, image/jpeg, image/gif, image/bmp, image/tiff, image/webp';
          break;
        default:
          self.accept = '';
          break;
      }
    },
    download() {
      const data = [];
      data.push('\ufefftext_org\r\n');
      data.push('ปาฝฝา 10 บาท\r\n');
      data.push('ดินสอ 20 บาท\r\n');
      data.push('ถาม:ฝินข้าว ตอบ:ฝินหมูปิ้ง');

      const a = document.createElement('a');
      let blob = new Blob(data, { type: 'data:text/csv;charset=UTF-8' });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = 'upload_vector.csv';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
    ReProcess() {
      let self = this;
      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == '' || this.requestVector.MaxLimitedCharacter == undefined) {
        alert('Please fill in the Custom Max Character');
        return;
      }
      self.$swal
        .fire({
          icon: 'warning',
          title: this.$t('vectorReprocess'),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            try {
              let data = {
                vectordbName: self.searchVectorDBName2,
                MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
                groupReplaceID: self.tempgroupReplaceID == null ? null : JSON.stringify(self.tempgroupReplaceID),
                DetectLanguage: self.requestVector.DetectLanguage,
              };
              self.$call.ReProcessedVector(
                data,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.GetByVector();
                  }
                },
                (errorResource) => {
                  console.error(errorResource.message);
                }
              );
            } catch (error) {
              this.LogTrace(error, 'ReProcess');
            }
          }
        });
    },
    ReFresh() {
      try {
        let self = this;
        // console.log("ReFresh");
        if (
          (self.$route.query.name != null && self.$route.query.name != "") ||
          (self.searchVectorDBName2 != null && self.searchVectorDBName2 != "")
        ) {
          let { page, itemsPerPage } = self.options2;
          self.sortBy = self.options2.sortBy?.[0]?.key || null;
          self.sortDesc = self.options2.sortBy?.[0]?.order === 'desc' || false;
          let temp = {
            page: self.isSearch ? 1 : page,
            perPage: itemsPerPage != -1 ? itemsPerPage : null,
            name: self.$route.query.name != null ? self.$route.query.name : self.searchVectorDBName2,
            text_org: self.searchtext_org,
            sortDesc: self.sortDesc,
            sortBy: self.sortBy,
          };
          this.loadingTable = true;
          self.$call.ReFreshVector(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.dataUpdate = dataResponse.data.dataUpdate;
                self.dataAll = dataResponse.data.dataAll;
                self.exceptionFlag = dataResponse.data.exceptionFlag;
                self.searchTotalTable2 = dataResponse.data.table.total;
                self.dataTable2 = dataResponse.data.table.data;
                self.totalTable = dataResponse.data.table.total;
                self.tempgroupReplaceID = dataResponse.data.groupReplaceID;
                // self.modelType = dataResponse.data.modelType;
                self.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
                self.requestVector.PersonalInfo = dataResponse.data.personalInformation;
                // self.requestVector.activeStatus = dataResponse.data.activeStatus;
                // self.requestVector.knowledgeType = dataResponse.data.knowledgeCategory;
                self.requestVector.effectiveStartDate = self.parseDateFromAPI(dataResponse.data.effectiveStartDate);
                self.requestVector.effectiveEndDate = self.parseDateFromAPI(dataResponse.data.effectiveEndDate);
                self.needsReprocessing = dataResponse.data.table.needsReprocessing;

                 // Populate configForm for Configuration Management Section
                self.showConfigSection = true;
                self.configForm.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
                self.configForm.effectiveStartDate = self.parseDateFromAPI(dataResponse.data.effectiveStartDate);
                self.configForm.effectiveEndDate = self.parseDateFromAPI(dataResponse.data.effectiveEndDate);
                self.configForm.DetectLanguage = dataResponse.data.detectLanguage;
                self.configForm.PersonalInfo = dataResponse.data.personalInformation;
                self.configForm.activeStatus = dataResponse.data.activeStatus ?? true;
                self.configForm.knowledgeType = dataResponse.data.knowledgeCategory;
                self.configForm.Title = dataResponse.data.title;
                self.configForm.SubTitle = dataResponse.data.subTitle;
                self.configForm.chunkOverlapChars = dataResponse.data.chunkOverlapChars ?? 0;
              }
              self.loadingTable = false;
              self.totalTable = self.totalTable + 1;
              self.isSearch2 = false;
              self.isFirst2 = false;
            },
            (errorResource) => {
              self.isSearch2 = false;
              self.loadingTable = false;
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, 'ReFresh');
      }
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        if (
          (self.$route.query.name != null && self.$route.query.name != "") ||
          (self.searchVectorDBName2 != null && self.searchVectorDBName2 != "")
        ) {
          if (self.dataUpdate == self.dataAll || self.exceptionFlag || (self.dataUpdate <= 0 && self.dataAll <= 0))
          {
            death_waiting = false;
          }
          else 
          {
            this.ReFresh();
          }
          if (window.location.pathname != "/UploadVector")
            death_waiting = false;
        } else if(self.$route.query.name == null) {
          death_waiting = false;
          this.loadingTable = false;
        } else {
          death_waiting = false;
          this.loadingTable = false;
        }
        
        if (death_waiting) {
          await new Promise((resolve) => setTimeout(resolve, 5000));
        }
      } while (death_waiting);
    },
    closeUploaddialog() {
      let self = this;
      self.EditVector = false;
      self.Edit.id = null;
      self.Edit.textORG = null;
    },
    closeUploaddialogAdd() {
      let self = this;
      self.AddVector = false;
      self.Add.id = null;
      self.Add.textORG = null;
    },
    GetDDGroupReplaceDB() {
      let self = this;
      self.dialog = true;
      const vectordbName = self.$route.query.name || self.searchVectorDBName2;
      self.$call.GetDDGroupReplaceDBForVector(
        vectordbName,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGroupReplace = dataResponse.data == null ? [] : dataResponse.data;
          } else {
            self.DDGroupReplace = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    GetMaxLimitedCharacter() {
      let self = this;
      self.dialog = true;
      self.$call.GetMaxLimitedCharacter(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.requestVector.MaxLimitedCharacter = dataResponse.data;
          } else {
            self.requestVector.MaxLimitedCharacter = null;
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    TemplateVectorDialog() {
      let self = this;
      self.TemplateVector = true;
    },

    closeTemplateVectorDialog() {
      let self = this;
      self.TemplateVector = false;
    },

    ShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable2.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable2.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    Search() {
      let self = this;
      self.isSearch2 = true;
      self.options2.page = 1;
      self.ReFresh();
    },
    UpdatePersonalInformation(item) {
      let self = this;
      self.dialog = true;
      var parameter = {
        VectorDBName: item,
      };
      self.$call.UpdatePersonalInformation(
        parameter,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.ReFresh();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    UpdateConfiguration() {
      let self = this;

      // Validate dates
      if (self.configForm.effectiveStartDate && self.configForm.effectiveEndDate) {
        if (new Date(self.configForm.effectiveEndDate) <= new Date(self.configForm.effectiveStartDate)) {
          self.$toast.error('Effective End Date must be greater than Effective Start Date');
          return;
        }
      }

      // Validate Title when Context by LLM is selected
      if (self.isContextByLLM && !self.configForm.Title) {
        self.$toast.error('Title is required when using Context by LLM');
        return;
      }

      // Validate SubTitle when Context by LLM is selected and subtitles are available
      if (self.isContextByLLM && self.configAvailableSubTitles.length > 0 && !self.configForm.SubTitle) {
        self.$toast.error('Sub-Title is required when using Context by LLM');
        return;
      }

      self.configLoading = true;

      var parameter = {
        vectorDBName: self.searchVectorDBName2,
        maxLimitedCharacter: self.configForm.MaxLimitedCharacter,
        effectiveStartDate: self.formatDateForAPI(self.configForm.effectiveStartDate),
        effectiveEndDate: self.formatDateForAPI(self.configForm.effectiveEndDate),
        detectLanguage: self.configForm.DetectLanguage,
        personalInformation: self.configForm.PersonalInfo,
        activeStatus: self.configForm.activeStatus ?? true,
        knowledgeCategory: self.configForm.knowledgeType,
        title: self.configForm.Title,
        subTitle: self.configForm.SubTitle,
        chunkOverlapChars: self.configForm.chunkOverlapChars,
      };

      self.$call.UpdateDocumentConfiguration(
        parameter,
        (dataResponse) => {
          self.configLoading = false;
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: 'Configuration updated successfully',
              showConfirmButton: false,
              timer: 1500,
            });
            self.GetByVector();
          } else {
            self.$toast.error(dataResponse.message || 'Failed to update configuration');
          }
        },
        (errorResource) => {
          self.configLoading = false;
          self.$toast.error('Error updating configuration');
          console.error(errorResource);
        }
      );
    },
  },
  mounted() {
    this.GetDate();
    this.AutoRefresh();
    this.GetDDGroupReplaceDB();

    if (this.$route.query.name) {
      this.searchVectorDBName2 = this.$route.query.name;
      this.showTable = true;
      this.actionEdit = true;
      this.flagNew = false;
      this.showConfigSection = true; // Show config section when editing existing document
      // this.requestVector.modelType = 1;
    } else {
      // this.requestVector.modelType = 1;
      this.dataUpdate = 0;
      this.GetMaxLimitedCharacter();
    }
    if (this.requestVector.MaxLimitedCharacter == null) {
      this.ReFresh();
    }
  },
};
</script>

<style scoped>
.required-asterisk {
  color: #f44336;
  margin-left: 2px;
  font-weight: bold;
}

.card2 {
  border-radius: 10px !important;
  margin-bottom: 1.5rem;
  margin-top: 1rem;
  padding: 0.75rem;
}

.text-container {
  display: flex;
  align-items: flex-start;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.text-content-show {
  overflow: hidden;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.responsive-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
}

/* Section Wrappers - ลด margin */
.config-wrapper,
.search-wrapper {
  margin-bottom: 20px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin: 0;
}

/* Cards - ลด border radius ๝ละ transition */
.config-card,
.search-card {
  border-radius: 8px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  transition: all 0.15s ease;
}

.config-card:hover,
.search-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.2);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.08);
}

.config-content,
.search-content {
  padding: 16px;
}

/* Form Sections - ลด margin */
.form-section {
  margin-bottom: 0px !important;
}

.subsection-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1rem;
  font-weight: 500;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 12px;
}

.subsection-icon {
  color: rgb(var(--v-theme-primary));
  font-size: 18px;
}

.section-divider {
  margin: 10px 0;
  opacity: 0.6;
}

/* Form Rows - ลด padding */
.form-row,
.search-row,
.settings-row {
  margin-bottom: 0;
}

.form-row .v-col,
.search-row .v-col,
.settings-row .v-col {
  padding-top: 6px;
  padding-bottom: 6px;
}

/* Input Wrappers - ลด gap */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
}

/* Help Icons */
.help-icon {
  color: rgba(var(--v-theme-primary), 0.7);
  cursor: help;
  transition: color 0.15s ease;
}

.help-icon:hover {
  color: rgb(var(--v-theme-primary));
}

/* Processing Item */
.processing-item {
  border-radius: 6px;
  margin: 1px 6px;
}

.processing-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.05);
}

.processing-avatar {
  border-radius: 4px;
}

/* Tooltip Images */
.tooltip-image {
  border-radius: 6px;
  overflow: hidden;
}

.tooltip-image img {
  display: block;
  border-radius: 6px;
}

/* Switch Components - ลดขนาด */
.switch-container-LangDetect {
  display: flex;
  align-items: flex-start;
  min-height: 36px;
  min-width: 80px;
  max-width: 300px;
  border-radius: 8px;
  border: 1px solid #0000001e;
}

.language-switch {
  margin: 0;
}

.switch-label-container {
  display: flex;
  align-items: center;
}

.switch-text {
  font-size: 0.8rem;
  color: rgb(var(--v-theme-on-surface));
}

/* Action Section - ลด padding */
.action-section {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  padding-top: 4px;
}

.action-left {
  display: flex;
  align-items: center;
}

.upload-action-wrapper {
  margin-right: 1rem;
  position: relative;
}

/* Style for Upload Button - matches DragDropFile style */
.styled-upload-btn {
  border-radius: 16px !important;
  background: linear-gradient(90deg, #00942c 0%, #2abf56 100%) !important;
  color: white !important;
  border: none !important;
  padding: 0 24px !important;
  height: 45px !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  text-transform: none !important;
  min-width: 120px !important;
  box-shadow: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
  margin: 0 !important;
}

.styled-upload-btn:hover {
  background: linear-gradient(90deg, #00942c 0%, #2abf56 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
}

.styled-upload-btn:disabled {
  background: linear-gradient(90deg, #9e9e9e 0%, #bdbdbd 100%) !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

.styled-upload-btn::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: -100% !important;
  width: 100% !important;
  height: 100% !important;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent) !important;
  transition: left 0.5s ease !important;
}

.styled-upload-btn:hover::before {
  left: 100% !important;
}

/* Style for DragDropFile Component */
.styled-upload-component {
  margin: 0 !important;
  padding: 0 !important;
}

/* Style the upload button inside DragDropFile */
.styled-upload-component :deep(.NoDragDrop .v-btn) {
  border-radius: 16px;
  background: linear-gradient(90deg, #00942c 0%, #2abf56 100%);
  /* background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important; */
  color: white !important;
  border: none !important;
  padding: 0 24px !important;
  height: 45px !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  text-transform: none !important;
  min-width: 120px !important;
  box-shadow: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
  margin: 0 !important;
}

/* Hover effect for upload button */
.styled-upload-component :deep(.NoDragDrop .v-btn:hover) {
  background: linear-gradient(90deg, #00942c 0%, #2abf56 100%) !important;
  /* background: linear-gradient(135deg, #45a049 0%, #4caf50 100%) !important; */
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
}

/* Animation effect */
.styled-upload-component :deep(.NoDragDrop .v-btn::before) {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: -100% !important;
  width: 100% !important;
  height: 100% !important;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent) !important;
  transition: left 0.5s ease !important;
}

.styled-upload-component :deep(.NoDragDrop .v-btn:hover::before) {
  left: 100% !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .upload-action-wrapper {
    margin-left: 0;
    margin-top: 12px;
    display: flex;
    justify-content: center;
  }

  .styled-upload-component :deep(.NoDragDrop .v-btn) {
    width: 100% !important;
    min-width: auto !important;
    height: 44px !important;
    font-size: 0.9rem !important;
  }
}

@media (max-width: 480px) {
  .styled-upload-component :deep(.NoDragDrop .v-btn) {
    height: 40px !important;
    font-size: 0.85rem !important;
    padding: 0 16px !important;
  }
}

/* Action Controls */
.action-controls-uploadvector {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* Buttons - ลดขนาด */

.edit-btn {
  color: rgb(255, 178, 34) !important;
  background: rgb(255, 241, 197) !important;
}
.edit-btn:hover {
  color: white !important;
  background: rgb(255, 178, 34) !important;
}
.info-btn {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.75rem;
}

/* Form Field Enhancements */
:deep(.v-field--variant-outlined) {
  border-radius: 6px;
}

:deep(.v-field--variant-outlined .v-field__outline) {
  --v-field-border-opacity: 0.25;
}

:deep(.v-field--variant-outlined.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  --v-field-border-width: 2px;
}

:deep(.v-field--variant-outlined:hover .v-field__outline) {
  --v-field-border-opacity: 0.4;
}

/* Input Focus Effects */
:deep(.v-text-field input),
:deep(.v-select .v-field__input),
:deep(.v-autocomplete .v-field__input) {
  transition: all 0.15s ease;
}

/* Field ขนาดเล็ฝลง */
:deep(.v-field--density-compact) {
  --v-field-padding-top: 4px;
  --v-field-padding-bottom: 4px;
}

:deep(.v-field--density-compact .v-field__input) {
  min-height: 32px;
  padding-top: 4px;
  padding-bottom: 4px;
}

/* Chip Enhancements */
:deep(.v-chip) {
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.75rem;
  height: 24px;
}

/* Switch ขนาดเล็ฝลง */
:deep(.v-switch) {
  transform: scale(0.9);
}

/* Tooltip ขนาดเล็ฝลง */
:deep(.v-tooltip .v-overlay__content) {
  font-size: 0.75rem;
  padding: 4px 8px;
}

/* Responsive Design */
@media (max-width: 960px) {
  .action-section {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .action-controls {
    justify-content: center;
  }

  .config-content,
  .search-content {
    padding: 12px;
  }

  .subsection-title {
    font-size: 0.9rem;
  }

  .section-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .action-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }

  .template-btn,
  .action-btn-doc,
  .info-btn {
    width: 100%;
    justify-content: center;
    height: 32px;
    font-size: 0.8rem;
  }

  .config-content,
  .search-content {
    padding: 8px;
  }
}

/* Animation - ลดระยะเวลา */
.config-wrapper,
.search-wrapper {
  opacity: 0;
  transform: translateY(10px);
  animation: slideInUp 0.25s ease forwards;
}

.search-wrapper {
  animation-delay: 0.05s;
}

@keyframes slideInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Template Dialog Styles */
.template-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.template-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  color: white;
  font-size: 20px;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  color: white;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
  color: white;
}

.close-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.template-content {
  padding: 24px;
  background-color: #fafafa;
}

.template-description {
  margin-bottom: 20px;
}

.alert-content {
  font-size: 0.875rem;
}

.template-instructions {
  margin: 8px 0 0 16px;
  padding: 0;
}

.template-instructions li {
  margin: 4px 0;
  line-height: 1.4;
}

.template-table-wrapper {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.template-table {
  background: white;
}

.template-table :deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

.template-table :deep(.v-data-table-header) {
  background-color: #f5f5f5;
}

.template-table :deep(.v-data-table-header th) {
  font-weight: 600;
  color: #424242;
  font-size: 0.875rem;
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 12px;
}

.template-row {
  transition: background-color 0.2s ease;
}

.template-row:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.mode-type-cell {
  padding: 16px 12px;
}

.mode-type-content {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.info-icon {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.custom-tooltip {
  font-size: 0.8rem;
  line-height: 1.4;
}

.download-cell {
  text-align: center;
  padding: 16px 8px;
}

.excel-buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  margin: 8px 0;
}

.download-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 0.75rem;
  border-radius: 8px;
  min-width: 70px;
  height: 32px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.excel-btn {
  margin-bottom: 4px;
}

.excel-multi-btn {
  font-size: 0.7rem;
  min-width: 75px;
}

.not-available {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
}

.template-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
}

.close-action-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 24px;
  height: 40px;
  min-width: 120px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .template-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  .template-header {
    padding: 16px 20px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    font-size: 28px;
  }

  .dialog-title {
    font-size: 1.25rem;
  }

  .dialog-subtitle {
    font-size: 0.8rem;
  }

  .template-content {
    padding: 16px;
  }

  .excel-buttons {
    flex-direction: row;
    gap: 4px;
  }

  .download-btn {
    font-size: 0.7rem;
    min-width: 60px;
    height: 28px;
  }

  .excel-multi-btn {
    font-size: 0.65rem;
    min-width: 65px;
  }

  .template-table :deep(.v-data-table-header th) {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .mode-type-cell,
  .download-cell {
    padding: 12px 6px;
  }
}

@media (max-width: 480px) {
  .template-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dialog-title {
    font-size: 1.1rem;
  }

  .dialog-subtitle {
    font-size: 0.75rem;
  }

  .excel-buttons {
    flex-direction: column;
    gap: 3px;
  }

  .download-btn {
    font-size: 0.65rem;
    min-width: 55px;
    height: 26px;
  }

  .template-instructions {
    font-size: 0.8rem;
  }
}

.actions-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 0.75rem 0.5rem;
  min-width: 140px;
  min-height: 80px;
  justify-content: center;
}

/* Edit Button Styling */
.edit-btn {
  background: rgba(33, 150, 243, 0.1) !important;
  border: 1px solid rgba(33, 150, 243, 0.3) !important;
  width: 40px !important;
  height: 40px !important;
}

.edit-btn:hover {
  background: rgba(33, 150, 243, 0.2) !important;
  border-color: rgba(33, 150, 243, 0.5) !important;
}

.edit-btn .v-icon {
  color: rgb(33, 150, 243) !important;
}

/* Delete Button Styling */
.delete-btn {
  background: rgba(244, 67, 54, 0.1) !important;
  border: 1px solid rgba(244, 67, 54, 0.3) !important;
  width: 40px !important;
  height: 40px !important;
}

.delete-btn:hover {
  background: rgba(244, 67, 54, 0.2) !important;
  border-color: rgba(244, 67, 54, 0.5) !important;
}

.delete-btn .v-icon {
  color: rgb(244, 67, 54) !important;
}

/* Disabled state — visually communicate the button can't be clicked */
.delete-btn.v-btn--disabled {
  background: rgba(0, 0, 0, 0.04) !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  opacity: 0.55 !important;
  cursor: not-allowed !important;
}

.delete-btn.v-btn--disabled .v-icon {
  color: rgba(0, 0, 0, 0.38) !important;
}

/* Enhanced Switch Container */
.switch-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 0.5rem;
  border-radius: 8px;
  background: rgba(76, 175, 80, 0.05);
  border: 1px solid rgba(76, 175, 80, 0.2);
  transition: all 0.2s ease;
  min-width: 80px;
}
.switch-container:hover {
  background: rgba(76, 175, 80, 0.1);
  border-color: rgba(76, 175, 80, 0.3);
}
.vector-switch {
  margin: 0;
  transform: scale(0.9);
}

.vector-switch :deep(.v-selection-control) {
  min-height: 28px;
}

/* Switch Label */
.switch-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: rgba(var(--v-theme-on-surface), 0.8);
  text-align: center;
  line-height: 1.2;
  transition: color 0.2s ease;
  min-width: 50px;
}
.action-buttons-group {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 4px 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}
.action-buttons-group:hover {
  background: rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.action-btn-doc {
  border-radius: 6px !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0 1px;
  opacity: 0.7;
  width: 32px !important;
  height: 32px !important;
}

.action-btn-doc:hover {
  opacity: 1;
  transform: translateY(-1px);
}
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
}
.action-buttons-group:hover .action-divider {
  background: rgba(0, 0, 0, 0.2);
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(25, 118, 210, 0.02);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Focus states */
.action-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}
@media (max-width: 768px) {
  .actions-container {
    gap: 8px;
    padding: 0.5rem 0.25rem;
    min-width: 120px;
  }

  .switch-container {
    padding: 0.25rem;
    min-width: 70px;
  }

  .switch-label {
    font-size: 0.65rem;
  }

  .action-buttons-group {
    flex-direction: column;
    gap: 2px;
    padding: 4px;
  }

  .action-divider {
    width: 80%;
    height: 1px;
    margin: 2px 0;
  }

  .action-btn {
    width: 28px !important;
    height: 28px !important;
  }

  .vector-switch {
    transform: scale(0.8);
  }
}

@media (max-width: 480px) {
  .actions-container {
    min-width: 100px;
    gap: 6px;
  }

  .switch-container {
    min-width: 60px;
  }

  .switch-label {
    font-size: 0.6rem;
  }
}

.toggle-section {
  display: flex;
  align-items: center;
}

.compact-toggle {
  background: rgba(255, 255, 255, 0.507);
  border-radius: 6px;
  padding: 0.25rem 0.75rem;
  border: 1px solid #e0e0e0a4;
  margin: 0;
  transform: scale(0.85);
}

.toggle-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 0.8rem;
  color: #424242;
}
/* Edit Dialog Styles */
.edit-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.edit-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  font-size: 24px;
  opacity: 0.9;
}

.header-text .dialog-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
}

.close-btn {
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.edit-content {
  padding: 24px;
  background-color: #fafafa;
}

.textarea-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.textarea-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
}

.content-textarea {
  background: white;
  border-radius: 8px;
}

.content-textarea :deep(.v-field) {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.content-textarea :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.15);
}

.edit-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.cancel-btn,
.save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 20px;
  height: 40px;
  min-width: 100px;
}

.cancel-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
}

/* .save-btn {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.save-btn:hover {
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.4);
} */

/* Responsive */
@media (max-width: 768px) {
  .edit-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .edit-header {
    padding: 16px 20px;
  }

  .header-text .dialog-title {
    font-size: 1.1rem;
  }

  .edit-content {
    padding: 16px;
  }

  .edit-actions {
    padding: 12px 16px;
    flex-direction: column;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
    margin: 0;
  }
}

/* Add Dialog Styles */
.add-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.add-header {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-header .header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.add-header .header-icon {
  font-size: 24px;
  opacity: 0.9;
}

.add-header .header-text .dialog-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.add-header .header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
}

.add-header .close-btn {
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.2s ease;
}

.add-header .close-btn:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.add-content {
  padding: 24px;
  background-color: #fafafa;
}

.add-content .textarea-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.add-content .textarea-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
}

.add-content .content-textarea {
  background: white;
  border-radius: 8px;
}

.add-content .content-textarea :deep(.v-field) {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.add-content .content-textarea :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15);
}

.add-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.add-actions .cancel-btn,
.add-actions .save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 20px;
  height: 40px;
  min-width: 100px;
}

.add-actions .cancel-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
}

.add-actions .save-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.add-actions .save-btn:hover {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

/* Responsive for Add Dialog */
@media (max-width: 768px) {
  .add-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .add-header {
    padding: 16px 20px;
  }

  .add-header .header-text .dialog-title {
    font-size: 1.1rem;
  }

  .add-content {
    padding: 16px;
  }

  .add-actions {
    padding: 12px 16px;
    flex-direction: column;
  }

  .add-actions .cancel-btn,
  .add-actions .save-btn {
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 480px) {
  .add-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px);
  }

  .add-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .add-header .header-text .dialog-title {
    font-size: 1rem;
  }

  .add-header .header-text .dialog-subtitle {
    font-size: 0.8rem;
  }
}
.switch-container-personal {
  display: flex;
  align-items: flex-start;
  min-height: 36px;
  min-width: 80px;
  max-width: 300px;
  border-radius: 8px;
  border: 1px solid rgba(255, 152, 0, 0.2);
  background-color: rgba(255, 248, 225, 0.5);
  transition: all 0.2s ease;
}

.switch-container-personal:hover {
  border-color: rgba(255, 152, 0, 0.4);
  background-color: rgba(255, 248, 225, 0.8);
}

.personal-switch {
  margin: 0;
}

.personal-switch :deep(.v-switch__track) {
  opacity: 0.6;
  background-color: rgba(255, 152, 0, 0.2) !important;
}

.personal-switch :deep(.v-switch__track--checked) {
  background-color: rgba(255, 152, 0, 0.6) !important;
}

.personal-switch .switch-label-container {
  display: flex;
  align-items: center;
}

.personal-switch .switch-text {
  font-weight: 500;
  font-size: 0.8rem;
  color: rgb(var(--v-theme-warning));
}

.template-btn {
  border-radius: 16px;
  border: 1px solid #37074e;
  height: 45px;
  color: #37074e;
}


/* Notification Badge */
.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #ff4757;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
  border: 2px solid white;
  animation: pulse 2s infinite;
}

/* Animations */
@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px rgba(255, 71, 87, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
  }
}

/* Configuration Management Section Styles */
.config-management-wrapper {
  margin-bottom: 20px;
}

.config-management-card {
  border-radius: 8px;
  border: 2px solid rgba(var(--v-theme-primary), 0.3);
  transition: all 0.2s ease;
}

.config-management-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.5);
  box-shadow: 0 4px 12px rgba(var(--v-theme-primary), 0.15);
}

.config-management-title {
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.08) 0%, rgba(var(--v-theme-primary), 0.04) 100%);
  font-size: 1.1rem;
  font-weight: 600;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(var(--v-border-color), 0.12);
}

.config-management-content {
  padding: 20px;
}

.update-config-btn {
  height: 42px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}

/* Markdown rendering styles for table cells */
.text-container.markdown-mode {
  text-align: left !important;
}

.text-container :deep(.markdown-content) {
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  background: transparent;
  font-size: inherit;
  text-align: left;
}

.text-content :deep(.markdown-content),
.text-content-show :deep(.markdown-content) {
  line-height: 1.4;
  text-align: left;
}

/* Reduce markdown heading sizes in table */
.text-container :deep(.markdown-content h1) { font-size: 1.1em; margin: 0.3em 0; }
.text-container :deep(.markdown-content h2) { font-size: 1.05em; margin: 0.2em 0; }
.text-container :deep(.markdown-content h3) { font-size: 1em; margin: 0.2em 0; }
.text-container :deep(.markdown-content h4),
.text-container :deep(.markdown-content h5),
.text-container :deep(.markdown-content h6) { font-size: 0.95em; margin: 0.2em 0; }
.text-container :deep(.markdown-content p) { margin: 0.3em 0; }
.text-container :deep(.markdown-content ul),
.text-container :deep(.markdown-content ol) { margin: 0.3em 0; padding-left: 1.2em; }
.text-container :deep(.markdown-content pre) {
  font-size: 0.85em;
  padding: 0.5em;
  margin: 0.3em 0;
  border-radius: 4px;
}
.text-container :deep(.markdown-content code) {
  font-size: 0.9em;
  padding: 0.1em 0.3em;
  border-radius: 3px;
}
.text-container :deep(.markdown-content table) {
  font-size: 0.85em;
  margin: 0.3em 0;
  border-collapse: collapse;
}
.text-container :deep(.markdown-content table th),
.text-container :deep(.markdown-content table td) {
  padding: 0.3em 0.5em;
  border: 1px solid rgba(var(--v-border-color), 0.12);
}
.text-container :deep(.markdown-content blockquote) {
  margin: 0.3em 0;
  padding-left: 0.8em;
  border-left: 3px solid rgba(var(--v-theme-primary), 0.3);
}
.text-container :deep(.markdown-content hr) {
  margin: 0.5em 0;
}
</style>
